<template>
    <div>
        <div class="border-bottom-light pt-3">
            <input type="text" class="form-control" v-model="seatingPlanName_" :disabled="!has_right_to_update_seatingplan" />
            <select v-model="seatingPlanColorType_" class="form-select align-middle d-inline-block mt-2">
                <option v-for="(color, i) in ALL_COLOR_TYPES" :value="color.value" :key="i">
                    {{ getColorTypeLabel(color.value) }}
                </option>
            </select>
        </div>
        <div class="border-bottom-light pt-2" v-if="has_right_to_update_seatingplan">
            <div>
                <strong>{{
                    $t("labels.booking.seatingPlan.elements.add", {
                        element: $tl("labels.booking.seatingPlan.elements.single"),
                    })
                }}</strong>
                <feather v-tooltip="getTooltipNotice('notices.booking.tablePlan.itemAdd')" type="info" class="ms-1 pointer tooltip-infos" />
            </div>
            <ShowElementsCategory :categoryName="$t('labels.booking.seatingPlan.elements.table')">
                <div
                    :ref="TABLE_DETAILS_TYPE_ROUND_TABLE.ref"
                    :data-type="TABLE_DETAILS_TYPE_ROUND_TABLE.value"
                    data-seats="4"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_ROUND_TABLE.value)">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 70.8 70.8"
                        style="enable-background: new 0 0 70.8 70.8"
                        xml:space="preserve"
                        fill="#808081">
                        <g>
                            <path
                                d="M35.4,61.9C20.8,61.9,8.9,50,8.9,35.4S20.8,9,35.4,9s26.5,11.9,26.5,26.4C61.9,50,50,61.9,35.4,61.9z M35.4,12 c-12.9,0-23.5,10.5-23.5,23.4s10.5,23.5,23.5,23.5s23.5-10.5,23.5-23.5C58.9,22.5,48.3,12,35.4,12z" />
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M21,6.9c-0.5,0-1.1-0.3-1.3-0.8c-0.4-0.7-0.1-1.6,0.6-2C20.6,3.9,28,0,35.6,0C43,0,50.2,3.9,50.5,4.1 c0.7,0.4,1,1.3,0.6,2s-1.3,1-2,0.6C49,6.7,42.2,3,35.6,3c-6.8,0-13.8,3.7-13.9,3.7C21.5,6.9,21.3,6.9,21,6.9z" />
                            </g>
                            <g>
                                <path
                                    d="M35.2,70.8c-7.4,0-14.6-3.9-14.9-4.1c-0.7-0.4-1-1.3-0.6-2s1.3-1,2-0.6c0.1,0,6.9,3.7,13.5,3.7 c6.8,0,13.8-3.7,13.9-3.7c0.7-0.4,1.6-0.1,2,0.6s0.1,1.6-0.6,2C50.2,66.9,42.8,70.8,35.2,70.8z" />
                            </g>
                        </g>
                        <g>
                            <g>
                                <path
                                    d="M63.9,21.1c0-0.5,0.3-1.1,0.8-1.3c0.7-0.4,1.6-0.1,2,0.6c0.2,0.3,4.1,7.7,4.1,15.3c0,7.4-3.9,14.6-4.1,14.9 c-0.4,0.7-1.3,1-2,0.6s-1-1.3-0.6-2c0-0.1,3.7-6.9,3.7-13.5c0-6.8-3.7-13.8-3.7-13.9C63.9,21.6,63.9,21.3,63.9,21.1z" />
                            </g>
                            <g>
                                <path
                                    d="M0,35.3c0-7.4,3.9-14.6,4.1-14.9c0.4-0.7,1.3-1,2-0.6s1,1.3,0.6,2c0,0.1-3.7,6.9-3.7,13.5 c0,6.8,3.7,13.8,3.7,13.9c0.4,0.7,0.1,1.6-0.6,2s-1.6,0.1-2-0.6C3.9,50.2,0,42.9,0,35.3z" />
                            </g>
                        </g>
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_SQUARE_TABLE.ref"
                    :data-type="TABLE_DETAILS_TYPE_SQUARE_TABLE.value"
                    data-seats="4"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_SQUARE_TABLE.value)">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 52.8 74"
                        style="enable-background: new 0 0 52.8 74"
                        xml:space="preserve"
                        fill="#808081">
                        <g>
                            <path
                                d="M48.5,63.3H4.4c-2.4,0-4.3-1.9-4.3-4.3V14.9c0-2.4,1.9-4.3,4.3-4.3h44.1c2.3,0,4.3,2,4.3,4.3V59C52.8,61.4,50.9,63.3,48.5,63.3z M4.4,13.6c-0.8,0-1.3,0.7-1.3,1.3V59c0,0.8,0.7,1.3,1.3,1.3h44.1c0.8,0,1.3-0.7,1.3-1.3V14.9c0-0.7-0.6-1.3-1.3-1.3H4.4z" />
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M12,6.9c-0.5,0-1.1-0.3-1.3-0.8c-0.4-0.7-0.1-1.6,0.6-2C11.6,3.9,19,0,26.6,0C34,0,41.2,3.9,41.5,4.1c0.7,0.4,1,1.3,0.6,2s-1.3,1-2,0.6C40,6.7,33.2,3,26.6,3c-6.8,0-13.8,3.7-13.9,3.7C12.5,6.8,12.2,6.9,12,6.9z" />
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path
                                        d="M26.2,74c-7.4,0-14.6-3.9-14.9-4.1c-0.7-0.4-1-1.3-0.6-2s1.3-1,2-0.6c0.1,0,6.9,3.7,13.5,3.7c6.8,0,13.8-3.7,13.9-3.7c0.7-0.4,1.6-0.1,2,0.6c0.4,0.7,0.1,1.6-0.6,2C41.2,70.1,33.8,74,26.2,74z" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_RECTANGLE_TABLE.ref"
                    :data-type="TABLE_DETAILS_TYPE_RECTANGLE_TABLE.value"
                    data-seats="4"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_RECTANGLE_TABLE.value)">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 96.3 74"
                        style="enable-background: new 0 0 96.3 74"
                        xml:space="preserve"
                        fill="#808081">
                        <g>
                            <path
                                d="M92,63.3H4.3C1.9,63.3,0,61.4,0,59V14.9c0-2.4,1.9-4.3,4.3-4.3h87.8c1.2,0,2.3,0.5,3.1,1.4c0.8,0.8,1.2,1.9,1.1,3v44.1C96.3,61.4,94.4,63.3,92,63.3z M4.3,13.6c-0.8,0-1.3,0.7-1.3,1.3V59c0,0.8,0.7,1.3,1.3,1.3H92c0.8,0,1.3-0.7,1.3-1.3V14.8c0-0.4-0.2-0.7-0.3-0.8c-0.2-0.3-0.6-0.4-0.9-0.4H4.3z" />
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M12,6.9c-0.5,0-1.1-0.3-1.3-0.8c-0.4-0.7-0.1-1.6,0.6-2C11.6,3.9,19,0,26.6,0C34,0,41.2,3.9,41.5,4.1c0.7,0.4,1,1.3,0.6,2s-1.3,1-2,0.6C40,6.7,33.2,3,26.6,3c-6.8,0-13.8,3.7-13.9,3.7C12.5,6.8,12.2,6.9,12,6.9z" />
                                </g>
                            </g>
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M26.2,74c-7.4,0-14.6-3.9-14.9-4.1c-0.7-0.4-1-1.3-0.6-2s1.3-1,2-0.6c0.1,0,6.9,3.7,13.5,3.7c6.8,0,13.8-3.7,13.9-3.7c0.7-0.4,1.6-0.1,2,0.6c0.4,0.7,0.1,1.6-0.6,2C41.2,70.1,33.8,74,26.2,74z" />
                                </g>
                            </g>
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M57.2,6.9c-0.5,0-1.1-0.3-1.3-0.8c-0.4-0.7-0.1-1.6,0.6-2C56.8,3.9,64.2,0,71.8,0c7.4,0,14.6,3.9,14.9,4.1c0.7,0.4,1,1.3,0.6,2s-1.3,1-2,0.6C85.2,6.7,78.4,3,71.8,3C65,3,58,6.7,57.9,6.7C57.7,6.8,57.4,6.9,57.2,6.9z" />
                                </g>
                            </g>
                        </g>
                        <g>
                            <g>
                                <g>
                                    <path
                                        d="M71.3,74c-7.4,0-14.6-3.9-14.9-4.1c-0.7-0.4-1-1.3-0.6-2s1.3-1,2-0.6c0.1,0,6.9,3.7,13.5,3.7c6.8,0,13.8-3.7,13.9-3.7c0.7-0.4,1.6-0.1,2,0.6c0.4,0.7,0.1,1.6-0.6,2C86.3,70.1,78.9,74,71.3,74z" />
                                </g>
                            </g>
                        </g>
                    </svg>
                </div>
            </ShowElementsCategory>
            <ShowElementsCategory :categoryName="$t('labels.booking.seatingPlan.elements.structure')">
                <div
                    :ref="TABLE_DETAILS_TYPE_DELIMITER.ref"
                    :data-type="TABLE_DETAILS_TYPE_DELIMITER.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_DELIMITER.value)">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 484.3 174.7"
                        style="enable-background: new 0 0 484.3 174.7"
                        xml:space="preserve"
                        fill="#808081">
                        <path
                            class="st0"
                            d="M0.2,0v174.7h484.1h0V0H0.2z M472.3,45.4l-39.1,117.3h-27.3L456.1,12h16.2V45.4z M136.1,12h27.4l-50.2,150.7 H85.9L136.1,12z M73.2,162.7H45.9L96.1,12h27.4L73.2,162.7z M176.1,12h27.4l-50.2,150.7h-27.4L176.1,12z M216.1,12h27.4l-50.2,150.7 h-27.4L216.1,12z M256.1,12h27.3l-50.2,150.7h-27.3L256.1,12z M296.1,12h27.4l-50.2,150.7h-27.4L296.1,12z M336.1,12h27.3 l-50.2,150.7h-27.3L336.1,12z M376.1,12h27.3l-50.2,150.7h-27.3L376.1,12z M416.1,12h27.3l-50.2,150.7h-27.3L416.1,12z M43.5,12 l-31.3,93.6V12H43.5z M12.2,143.6L56.1,12h27.3L33.2,162.7h-21V143.6z M445.8,162.7l26.5-79.3v79.3H445.8z" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_STAIRS1.ref"
                    :data-type="TABLE_DETAILS_TYPE_STAIRS1.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_STAIRS1.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.5 62.5" fill="#808081">
                        <path
                            d="M53.75,50a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,53.75,50Zm-10-10a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,43.75,40Zm-10-10a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,33.75,30Zm-10-10a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,23.75,20ZM57.5,31.25A1.25,1.25,0,0,0,58.75,30V23L76.62,40.88a1.23,1.23,0,0,0,1.76,0,1.24,1.24,0,0,0,0-1.76L60.52,21.25h7a1.25,1.25,0,0,0,0-2.5h-10a1.15,1.15,0,0,0-.48.1,1.22,1.22,0,0,0-.67.67,1.18,1.18,0,0,0-.1.48V30A1.25,1.25,0,0,0,57.5,31.25ZM63.75,60a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,63.75,60Zm10,10a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,73.75,70Zm8.75,8.75h-10a1.25,1.25,0,0,0,0,2.5h10a1.25,1.25,0,0,0,0-2.5Z"
                            transform="translate(-11.25 -18.75)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_STAIRS1_RIGHT.ref"
                    :data-type="TABLE_DETAILS_TYPE_STAIRS1_RIGHT.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_STAIRS1_RIGHT.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.41 62.4" fill="#808081">
                        <path
                            d="M51.11,12.4h10a1.29,1.29,0,0,0,1.2-1.2,1.22,1.22,0,0,0-1.2-1.2h-10a1.22,1.22,0,0,0-1.2,1.2A1.15,1.15,0,0,0,51.11,12.4Zm-23.7-1.2V.8a1.58,1.58,0,0,0-.7-.7.9.9,0,0,0-.5-.1h-10a1.4,1.4,0,0,0-1.3,1.3,1.22,1.22,0,0,0,1.2,1.2h7L5.31,20.4a1.27,1.27,0,0,0,0,1.8,1.22,1.22,0,0,0,.9.4,1.49,1.49,0,0,0,.9-.4L25,4.3v7a1.22,1.22,0,0,0,1.2,1.2A1.31,1.31,0,0,0,27.41,11.2Zm33.8-8.8h10a1.29,1.29,0,0,0,1.2-1.2A1.31,1.31,0,0,0,71.11,0h-10a1.22,1.22,0,0,0-1.2,1.2A1.18,1.18,0,0,0,61.21,2.4Zm-20.1,20h10a1.29,1.29,0,0,0,1.2-1.2,1.22,1.22,0,0,0-1.2-1.2h-10a1.22,1.22,0,0,0-1.2,1.2A1.15,1.15,0,0,0,41.11,22.4Zm-10,10h10a1.2,1.2,0,1,0,0-2.4h-10a1.22,1.22,0,0,0-1.2,1.2A1.15,1.15,0,0,0,31.11,32.4Zm-20,20h10a1.2,1.2,0,0,0,0-2.4h-10a1.22,1.22,0,0,0-1.2,1.2A1.15,1.15,0,0,0,11.11,52.4ZM0,61.2a1.22,1.22,0,0,0,1.2,1.2h10a1.2,1.2,0,0,0,0-2.4h-10A1.15,1.15,0,0,0,0,61.2Zm21.1-18.8h10a1.2,1.2,0,1,0,0-2.4h-10a1.22,1.22,0,0,0-1.2,1.2A1.15,1.15,0,0,0,21.11,42.4Z"
                            transform="translate(0 0)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_STAIRS2.ref"
                    :data-type="TABLE_DETAILS_TYPE_STAIRS2.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_STAIRS2.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.5 63.75" fill="#808081">
                        <path
                            d="M53.75,50a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,53.75,50Zm-10-10a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,43.75,40Zm-10-10a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,33.75,30Zm-10-10a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,23.75,20ZM74.48,38.75h-7a1.25,1.25,0,0,0,0,2.5h10a1.18,1.18,0,0,0,.48-.1,1.22,1.22,0,0,0,.67-.67,1.18,1.18,0,0,0,.1-.48V30a1.25,1.25,0,0,0-2.5,0v7L58.38,19.12a1.24,1.24,0,0,0-1.76,1.76ZM63.75,60a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,63.75,60Zm10,10a1.25,1.25,0,0,0-1.25-1.25h-10a1.25,1.25,0,0,0,0,2.5h10A1.25,1.25,0,0,0,73.75,70ZM82.5,80h-10a1.25,1.25,0,0,0,0,2.5h10a1.25,1.25,0,0,0,0-2.5Z"
                            transform="translate(-11.25 -18.75)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_STAIRS2_RIGHT.ref"
                    :data-type="TABLE_DETAILS_TYPE_STAIRS2_RIGHT.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_STAIRS2_RIGHT.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72.41 63.68" fill="#808081">
                        <path
                            d="M51.11,12.5h10a1.29,1.29,0,0,0,1.2-1.2,1.22,1.22,0,0,0-1.2-1.2h-10a1.22,1.22,0,0,0-1.2,1.2A1.29,1.29,0,0,0,51.11,12.5Zm10.1-10h10a1.22,1.22,0,0,0,1.2-1.2A1.18,1.18,0,0,0,71.11.1h-10a1.22,1.22,0,0,0-1.2,1.2A1.31,1.31,0,0,0,61.21,2.5Zm-20.1,20h10a1.29,1.29,0,0,0,1.2-1.2,1.22,1.22,0,0,0-1.2-1.2h-10a1.22,1.22,0,0,0-1.2,1.2A1.29,1.29,0,0,0,41.11,22.5Zm-14-20.3A1.27,1.27,0,1,0,25.31.4L7.41,18.3v-7a1.5,1.5,0,0,0-1.3-1.4,1.22,1.22,0,0,0-1.2,1.2v10a.9.9,0,0,0,.1.5,1.58,1.58,0,0,0,.7.7.9.9,0,0,0,.5.1h10a1.29,1.29,0,0,0,1.2-1.2,1.22,1.22,0,0,0-1.2-1.2h-7Zm-16,50.3h10a1.2,1.2,0,1,0,0-2.4h-10a1.22,1.22,0,0,0-1.2,1.2A1.29,1.29,0,0,0,11.11,52.5ZM0,62.5a1.22,1.22,0,0,0,1.2,1.2h10a1.2,1.2,0,0,0,0-2.4h-10A1.1,1.1,0,0,0,0,62.5Zm31.1-30h10a1.2,1.2,0,1,0,0-2.4h-10a1.22,1.22,0,0,0-1.2,1.2A1.29,1.29,0,0,0,31.11,32.5Zm-10,10h10a1.2,1.2,0,1,0,0-2.4h-10a1.22,1.22,0,0,0-1.2,1.2A1.29,1.29,0,0,0,21.11,42.5Z"
                            transform="translate(0 -0.02)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_STAIRS3.ref"
                    :data-type="TABLE_DETAILS_TYPE_STAIRS3.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_STAIRS3.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.12 68.06" fill="#808081">
                        <path
                            d="M73.78,16A2.07,2.07,0,0,0,72,18V32c-4.71-.07-9.57.12-14.22,0A2.07,2.07,0,0,0,56,34V48c-4.71-.07-9.57.12-14.22,0A2.07,2.07,0,0,0,40,50V64c-4.71-.07-9.57.12-14.22,0A2.07,2.07,0,0,0,24,66V80H7.81A2,2,0,0,0,8,84H25.62A2.1,2.1,0,0,0,28,82V68H41.62A2.1,2.1,0,0,0,44,66V52H57.62A2.1,2.1,0,0,0,60,50V36H73.62A2.1,2.1,0,0,0,76,34V20H92a2,2,0,1,0,0-4H90C84.63,15.92,79.1,16.13,73.78,16Z"
                            transform="translate(-5.9 -15.97)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_STAIRS3_LEFT.ref"
                    :data-type="TABLE_DETAILS_TYPE_STAIRS3_LEFT.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_STAIRS3_LEFT.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 88.11 68.05" fill="#808081">
                        <path
                            d="M0,2A2,2,0,0,0,2,4H18V18a2.11,2.11,0,0,0,2.4,2H34V34a2.11,2.11,0,0,0,2.4,2H50V50a2.11,2.11,0,0,0,2.4,2H66V66a2.11,2.11,0,0,0,2.4,2H86a2,2,0,1,0,.2-4H70V50a2,2,0,0,0-1.8-2c-4.6.1-9.5-.1-14.2,0V34a2,2,0,0,0-1.8-2c-4.6.1-9.5-.1-14.2,0V18a2,2,0,0,0-1.8-2c-4.6.1-9.5-.1-14.2,0V2a2,2,0,0,0-1.8-2C14.89.1,9.39-.1,4,0H2A2.07,2.07,0,0,0,0,2Z"
                            transform="translate(0.01 0.03)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_STAIRS4.ref"
                    :data-type="TABLE_DETAILS_TYPE_STAIRS4.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_STAIRS4.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50.95 77.37" fill="#808081">
                        <path
                            d="M70.6,9.81H65.71a3.39,3.39,0,0,0-3.38,3.38v1.19H34.67V13.19a3.39,3.39,0,0,0-3.38-3.38H26.4A3.39,3.39,0,0,0,23,13.19V83.8a3.38,3.38,0,0,0,3.38,3.38h4.89a3.38,3.38,0,0,0,3.38-3.38V82.62H62.33V83.8a3.38,3.38,0,0,0,3.38,3.38H70.6A3.38,3.38,0,0,0,74,83.8V13.19A3.39,3.39,0,0,0,70.6,9.81Zm-8.27,6.83v5.13H34.67V16.64Zm0,49.07H34.67V60.58H62.33Zm0,2.26v5H34.67V68ZM34.67,58.33v-5H62.33v5Zm27.66-7.26H34.67V45.93H62.33ZM34.67,43.68v-5H62.33v5Zm27.66-7.26H34.67V31.28H62.33ZM34.67,29V24H62.33v5ZM32.41,83.8a1.12,1.12,0,0,1-1.12,1.13H26.4a1.12,1.12,0,0,1-1.12-1.13V13.19a1.12,1.12,0,0,1,1.12-1.12h4.89a1.12,1.12,0,0,1,1.12,1.12V83.8Zm2.26-3.44V75.23H62.33v5.13ZM71.72,83.8a1.12,1.12,0,0,1-1.12,1.13H65.71a1.12,1.12,0,0,1-1.12-1.13V13.19a1.12,1.12,0,0,1,1.12-1.12H70.6a1.12,1.12,0,0,1,1.12,1.12Z"
                            transform="translate(-23.02 -9.81)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_DOOR1.ref"
                    :data-type="TABLE_DETAILS_TYPE_DOOR1.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_DOOR1.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 32.3" fill="#808081">
                        <path
                            d="M3.5,41.42v6.23a.5.5,0,0,0,.5.5H19.44a.52.52,0,0,0,.5-.5V41.42A24.64,24.64,0,0,1,44.06,16.87V47.63a.5.5,0,0,0,.5.5H60a.5.5,0,0,0,.5-.5V41.41a.5.5,0,0,0-.5-.5H45.06V16.35a.52.52,0,0,0-.5-.5A25.65,25.65,0,0,0,19,40.92H4A.5.5,0,0,0,3.5,41.42Zm56,5.72H48V41.92H59.5Zm-12.5,0H45V41.92h2Zm-28.06,0h-2V41.92h2ZM4.5,41.92H16v5.23H4.5Z"
                            transform="translate(-3.5 -15.85)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_DOOR2.ref"
                    :data-type="TABLE_DETAILS_TYPE_DOOR2.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_DOOR2.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 57 32.3" fill="#808081">
                        <path
                            d="M60,40.92H45A25.65,25.65,0,0,0,19.44,15.85a.52.52,0,0,0-.5.5V40.91H4a.5.5,0,0,0-.5.5v6.22a.5.5,0,0,0,.5.5H19.44a.5.5,0,0,0,.5-.5V16.87A24.64,24.64,0,0,1,44.06,41.42v6.23a.52.52,0,0,0,.5.5H60a.5.5,0,0,0,.5-.5V41.42A.5.5,0,0,0,60,40.92Zm-55.5,1H16v5.22H4.5Zm12.46,0h2v5.22H17Zm28.1,0h2v5.23h-2ZM59.5,47.15H48V41.92H59.5Z"
                            transform="translate(-3.5 -15.85)" />
                    </svg>
                </div>
            </ShowElementsCategory>
            <ShowElementsCategory :categoryName="$t('labels.booking.seatingPlan.elements.decoration')">
                <div
                    :ref="TABLE_DETAILS_TYPE_FLOWER.ref"
                    :data-type="TABLE_DETAILS_TYPE_FLOWER.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_FLOWER.value)">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 484.3 484.3"
                        style="enable-background: new 0 0 484.3 484.3"
                        xml:space="preserve"
                        fill="#808081">
                        <path
                            d="M482.3,237.2c-12.7-12.7-27.1-23.1-42.4-31.1V63.6c0-10.6-8.6-19.3-19.3-19.3H278.2 C270.1,28.9,259.6,14.6,247,2c-2.7-2.7-7.1-2.7-9.8,0c-12.7,12.7-23.1,27-31.1,42.3H63.6C53,44.3,44.3,53,44.3,63.6v142.5 c-15.5,8.1-29.8,18.5-42.3,31.2c-2.7,2.7-2.7,7.1,0,9.8c12.6,12.6,26.9,23.1,42.3,31.2v142.5c0,10.6,8.6,19.3,19.3,19.3h142.5 c8.1,15.5,18.5,29.8,31.2,42.4c1.3,1.3,3.1,2,4.9,2c1.8,0,3.6-0.7,4.9-2c12.7-12.8,23.1-27.1,31.1-42.4h142.5 c10.6,0,19.3-8.6,19.3-19.3V278.2c15.5-8.1,29.8-18.6,42.4-31.2C485,244.3,485,239.9,482.3,237.2z M420.7,56.3c4,0,7.3,3.3,7.3,7.3 v136.8c-17-7.2-34.9-11.7-53.1-13.3c26.2-31,40.8-70.5,40.6-111.4c0-3.8-3.1-6.9-6.9-6.9c-42,0.1-81.1,15.2-111.4,40.7 c-1.6-18.4-6.1-36.4-13.3-53.2H420.7z M223.6,257.7c-0.1-0.1-0.2-0.2-0.2-0.3c-3.4-4.2-5.4-9.5-5.4-15.3c0-7.4,3.3-13.9,8.5-18.4 c0.2-0.2,0.4-0.3,0.6-0.5c4.1-3.3,9.4-5.3,15.1-5.3c0.8,0,1.5,0,2.3,0.1c0,0,0,0,0,0c6.5,0.6,12.3,3.8,16.3,8.5 c0.1,0.1,0.2,0.2,0.2,0.3c3.4,4.2,5.4,9.5,5.4,15.3c0,7.4-3.4,14.1-8.6,18.5c-0.1,0.1-0.2,0.2-0.3,0.2c-4.2,3.4-9.5,5.4-15.3,5.4 C234.7,266.4,228,263,223.6,257.7z M231,278.6c-7,29.5-21.9,55.5-42.3,76c-0.1,0.1-0.2,0.2-0.3,0.3c-27.4,27.4-64.7,44.7-105.6,46.6 c1.6-38.9,17.6-75.9,44.8-103.7c31.8-0.5,62.9-9.8,89.7-26.8C221.2,274.4,225.9,277,231,278.6z M253.2,205.8 c7-29.5,21.9-55.5,42.3-76c0.1-0.1,0.2-0.2,0.3-0.3c27.4-27.4,64.7-44.7,105.6-46.6c-1.6,38.9-17.6,75.9-44.7,103.7 c-31,0.5-62.1,9.4-89.7,26.9C263.1,210,258.4,207.3,253.2,205.8z M242.1,16.9c26.4,28.7,41.2,66.1,41.8,104.9 c-21.6,22.3-37.3,50.5-44.5,82.4c-5.5,0.4-10.6,1.9-15.2,4.4c-15.8-25.5-23.7-54.2-23.9-82.9c0.1-0.6,0.1-1.3,0-1.9 C200.5,85.3,214.7,47,242.1,16.9z M213.4,217.3c-3.4,4-6.1,8.6-7.6,13.8c-29.5-7-55.5-21.9-76-42.3c-0.1-0.1-0.2-0.2-0.3-0.3 C102,160.9,84.7,123.7,82.8,82.8c38.9,1.6,75.9,17.6,103.7,44.8C187.1,158.6,195.9,189.7,213.4,217.3z M56.3,63.6 c0-4,3.3-7.3,7.3-7.3h136.9c-7.3,17-11.7,34.9-13.3,53.1c-31-26.3-70.5-40.8-111.4-40.6c-3.8,0-6.9,3.1-6.9,6.9 c0.1,42,15.2,81.1,40.7,111.4c-18.4,1.6-36.4,6.1-53.2,13.3V63.6z M121.9,200.4c22.3,21.6,50.5,37.3,82.3,44.5 c0.4,5.5,1.9,10.6,4.4,15.2c-25.5,15.8-54.2,23.7-82.9,23.9c-0.6-0.1-1.3-0.1-1.9,0c-38.5-0.2-76.8-14.3-106.9-41.8 C45.6,215.8,83,201,121.9,200.4z M63.6,427.9c-4,0-7.3-3.3-7.3-7.3V283.9c16.8,7.2,34.7,11.7,53.1,13.3 c-26.2,31-40.8,70.5-40.6,111.4c0,3.8,3.1,6.9,6.9,6.9c42-0.1,81.1-15.2,111.4-40.7c1.6,18.4,6.1,36.3,13.3,53.1H63.6z M242.1,467.4 c-26.4-28.7-41.2-66-41.8-104.9c21.6-22.3,37.3-50.5,44.5-82.4c5.4-0.4,10.6-1.9,15.1-4.4c15.8,25.5,23.7,54.2,23.9,82.9 c-0.1,0.6-0.1,1.3,0,1.9C283.7,399.1,269.6,437.3,242.1,467.4z M270.9,267c3.4-4,6.1-8.6,7.6-13.8c29.5,7,55.6,21.9,76,42.3 c0.1,0.1,0.2,0.2,0.3,0.3c27.4,27.4,44.7,64.7,46.6,105.6c-38.9-1.6-75.9-17.6-103.7-44.7C297.2,325.7,288.4,294.6,270.9,267z  M427.9,420.7c0,4-3.3,7.3-7.3,7.3H283.9c7.2-17,11.7-34.9,13.3-53.1c31,26.2,70.5,40.8,111.4,40.6c3.8,0,6.9-3.1,6.9-6.9 c-0.1-42-15.2-81.1-40.7-111.4c18.4-1.6,36.3-6.1,53.1-13.3V420.7z M362.4,283.9c-22.3-21.6-50.5-37.3-82.4-44.5 c-0.4-5.4-1.9-10.6-4.4-15.2c25.5-15.8,54.2-23.7,82.9-23.9c0.6,0.1,1.3,0.1,1.9,0c38.5,0.2,76.8,14.3,106.9,41.8 C438.7,268.5,401.3,283.4,362.4,283.9z" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_AQUARIUM.ref"
                    :data-type="TABLE_DETAILS_TYPE_AQUARIUM.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_AQUARIUM.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500.1 396.21" fill="#808081">
                        <path
                            d="M189.3,323.1c-1.3-1.2-2.8-2.5-4.6-4-3.8-3.2-8.5-7.2-13.1-11.9a39.36,39.36,0,0,0-23.4-11.6.76.76,0,0,1-.4-.1c-.2-.7-.5-1.8-.7-2.7-1.6-6.3-2.7-10.2-5.8-10.8-2-.4-7.7.4-13.6,2.1-5.5,1.7-13.2,4.8-18.4,10.5a78,78,0,0,1-13.4,11.6c-2.6,1.8-3.6,2.6-3.8,4.1a2.53,2.53,0,0,0,.6,2.1,39,39,0,0,0,3.2,2.8,32.92,32.92,0,0,1-8.4,4.5A8.71,8.71,0,0,1,77.2,316c-3.6-5.9-10.5-13.2-22.8-13.9a2.55,2.55,0,0,0-2.2,1c-1.2,1.5-1.1,3.7,2.3,11.2,1.9,4.2,4.4,9,6.2,12.2l.3.5c1.1,2.1,1.8,3.4,1.2,4.9v.1c-.8,1.3-3.3,5.4-5.6,9.6a71.79,71.79,0,0,0-3.7,7.4c-1.1,2.5-2,5.2-.4,6.8a2.28,2.28,0,0,0,1.9.7c12.4-.6,19.3-6.2,22.9-10.8a8.51,8.51,0,0,1,9.9-2.6c2.4,1,4.6,2.1,6.1,2.9a3.59,3.59,0,0,0-1.7,2.7,2.8,2.8,0,0,0,1,2.4l.1.1a58.31,58.31,0,0,0,13.4,9.7c5.5,2.9,8.8,1.5,10.7.7.2-.1.5-.2.7-.3,2.4,1.2,13,5,25.3,5,8.2,0,17-1.7,24.6-6.9a89,89,0,0,0,23.4-23.3A9.85,9.85,0,0,0,189.3,323.1Zm-2.6,10.3a84.71,84.71,0,0,1-22,22c-9,6.2-20.2,6.5-28,5.7a59.45,59.45,0,0,1-16.8-4.1c-2-1.2-3.8-.4-5,.1-1.5.6-3.1,1.3-6.5-.5a54.82,54.82,0,0,1-10.7-7.4,5.4,5.4,0,0,0,1.8-3.6,2.53,2.53,0,0,0-1.2-2.4,75.94,75.94,0,0,0-9.2-4.7,13.61,13.61,0,0,0-15.8,4.1c-2.6,3.4-7.4,7.4-15.9,8.6a148.15,148.15,0,0,1,9.3-16.8,2.1,2.1,0,0,0,.4-1.1c1.1-3.5-.5-6.5-1.7-8.7l-.2-.4c-4.7-8.7-7-13.8-8-16.6a22.57,22.57,0,0,1,15.7,11.1,13.68,13.68,0,0,0,16.3,5.9,44.43,44.43,0,0,0,12.5-7.3,2.5,2.5,0,0,0,0-4c-1.1-.8-2.3-1.7-3.3-2.5.1-.1.3-.2.4-.3A78.07,78.07,0,0,0,113,298.2c7.6-8.3,22.8-11.1,26.8-11.1h.2c.8,1.2,1.7,5.1,2.2,7,.1.4.2.7.3,1.1-12.6.2-21.1,5.6-26.8,9.3a27.32,27.32,0,0,1-5.5,3.1,2.59,2.59,0,0,0-1.7,3.2,2.46,2.46,0,0,0,2.4,1.8,1.7,1.7,0,0,0,.7-.1,25.74,25.74,0,0,0,6.8-3.7c6-3.9,14.3-9.2,27.1-8.5.5.2,1.1.2,1.9.4a34.39,34.39,0,0,1,20.5,10.2c4.8,4.9,9.6,9,13.5,12.3,1.7,1.5,3.2,2.7,4.5,3.9A4.64,4.64,0,0,1,186.7,333.4Z"
                            transform="translate(-1 -33.89)" />
                        <path
                            d="M148.6,332.9c-.6-5,.5-12.7,4.4-17.6a2.55,2.55,0,0,0-.4-3.6,2.43,2.43,0,0,0-3.5.4c-4.9,6.1-6.3,15.1-5.5,21.4.9,6.8,2.6,13.8,9.2,19.5a2.66,2.66,0,0,0,1.6.6,2.46,2.46,0,0,0,1.9-.9,2.54,2.54,0,0,0-.3-3.6C150.4,344.4,149.2,338.2,148.6,332.9Z"
                            transform="translate(-1 -33.89)" />
                        <ellipse cx="166.5" cy="292.21" rx="5.2" ry="6.3" />
                        <path
                            d="M318,202.5c-1.3-1.2-2.8-2.5-4.6-4-3.8-3.2-8.5-7.2-13.1-11.9A39.36,39.36,0,0,0,276.9,175a.76.76,0,0,1-.4-.1c-.2-.7-.5-1.8-.7-2.7-1.6-6.4-2.7-10.2-5.8-10.8-2-.4-7.7.4-13.6,2.1-5.5,1.7-13.2,4.8-18.4,10.5a78,78,0,0,1-13.4,11.6c-2.6,1.8-3.6,2.6-3.8,4.1a2.53,2.53,0,0,0,.6,2.1,39,39,0,0,0,3.2,2.8,32.92,32.92,0,0,1-8.4,4.5,8.71,8.71,0,0,1-10.3-3.7c-3.6-5.9-10.5-13.2-22.8-13.9a2.55,2.55,0,0,0-2.2,1c-1.2,1.5-1.1,3.7,2.3,11.2,1.9,4.2,4.4,9,6.2,12.2l.2.4c1.1,2.1,1.8,3.4,1.2,4.9v.1c-.8,1.3-3.3,5.4-5.6,9.6a71.79,71.79,0,0,0-3.7,7.4c-1.1,2.5-2,5.2-.4,6.8a2.28,2.28,0,0,0,1.9.7c12.4-.6,19.3-6.2,22.9-10.8a8.51,8.51,0,0,1,9.9-2.6c2.4,1,4.6,2.1,6.1,2.9a3.59,3.59,0,0,0-1.7,2.7,2.8,2.8,0,0,0,1,2.4l.1.1a58.31,58.31,0,0,0,13.4,9.7c5.5,2.9,8.8,1.5,10.7.7.2-.1.5-.2.7-.3,2.4,1.2,13,5,25.3,5,8.2,0,17-1.7,24.6-6.9a89,89,0,0,0,23.4-23.3A9.62,9.62,0,0,0,318,202.5Zm-2.5,10.4a84.71,84.71,0,0,1-22,22c-9,6.2-20.2,6.5-28,5.7a59.45,59.45,0,0,1-16.8-4.1c-2-1.2-3.8-.4-5,.1-1.5.6-3.1,1.3-6.5-.5a54.82,54.82,0,0,1-10.7-7.4,5.4,5.4,0,0,0,1.8-3.6,2.53,2.53,0,0,0-1.2-2.4,75.94,75.94,0,0,0-9.2-4.7,13.61,13.61,0,0,0-15.8,4.1c-2.6,3.4-7.4,7.4-15.9,8.6a148.15,148.15,0,0,1,9.3-16.8,2.1,2.1,0,0,0,.4-1.1c1.1-3.5-.5-6.5-1.7-8.7l-.2-.4c-4.7-8.7-7-13.8-8-16.6a22.57,22.57,0,0,1,15.7,11.1,13.68,13.68,0,0,0,16.3,5.9,44.43,44.43,0,0,0,12.5-7.3,2.5,2.5,0,0,0,0-4c-1.1-.8-2.3-1.7-3.3-2.5.1-.1.3-.2.4-.3a78.07,78.07,0,0,0,14.2-12.3c7.6-8.3,22.8-11.1,26.8-11.1h.2c.8,1.2,1.7,5.1,2.2,7,.1.4.2.7.3,1.1-12.6.2-21.1,5.6-26.8,9.3a27.32,27.32,0,0,1-5.5,3.1,2.59,2.59,0,0,0-1.7,3.2,2.46,2.46,0,0,0,2.4,1.8,1.7,1.7,0,0,0,.7-.1,25.74,25.74,0,0,0,6.8-3.7c6-3.9,14.3-9.2,27.1-8.5.5.2,1.1.2,1.9.4a34.39,34.39,0,0,1,20.5,10.2c4.8,4.9,9.6,9,13.5,12.3,1.7,1.5,3.2,2.7,4.5,3.9A4.73,4.73,0,0,1,315.5,212.9Z"
                            transform="translate(-1 -33.89)" />
                        <path
                            d="M277.3,212.3c-.6-5,.5-12.7,4.4-17.6a2.55,2.55,0,0,0-.4-3.6,2.43,2.43,0,0,0-3.5.4c-4.9,6.1-6.3,15.1-5.5,21.4.9,6.8,2.6,13.8,9.2,19.5a2.66,2.66,0,0,0,1.6.6,2.46,2.46,0,0,0,1.9-.9,2.54,2.54,0,0,0-.3-3.6C279.2,223.8,278,217.6,277.3,212.3Z"
                            transform="translate(-1 -33.89)" />
                        <ellipse cx="295.3" cy="171.61" rx="5.2" ry="6.3" />
                        <path
                            d="M498.1,33.89H3.9A3.06,3.06,0,0,0,1,37.08V426.91a3.06,3.06,0,0,0,2.9,3.19H498.2a3.06,3.06,0,0,0,2.9-3.19V37.08A3.21,3.21,0,0,0,498.1,33.89ZM447.4,343.51c.1-7.26,1.3-13.87,3.4-17.83,33.1-65.24-.8-138.85-1.2-139.51a2.68,2.68,0,0,0-3.2-1.54,3.13,3.13,0,0,0-2.2,3.08v3c.9,63.38-9.7,92.42-18.7,105.52a81,81,0,0,0-9.6,18.37c-.1-1.65-.1-3.19-.2-4.84-.1-18.71,5.1-37.63,10.2-56,6.8-24.65,13.8-50.07,8.1-75.48-3.4-15-10.8-28.06-17-37.74-9.4-15-20.4-29-31-42.58a2.61,2.61,0,0,0-3.5-.66,3.24,3.24,0,0,0-1.4,3.63l11.3,40.93c7.3,26.4,16.4,59.3,8.9,89.12a165.61,165.61,0,0,1-7.7,21.9c-2.4,5.94-4.8,12-6.7,18.26a113.4,113.4,0,0,0-4.7,31.69c-9.4-28.83-7.2-72.18-6.4-88.13.1-3,.2-4.85.2-5.95a3.13,3.13,0,0,0-2.2-3.08,2.75,2.75,0,0,0-3.2,1.65c-.3.66-30,66.35-9.4,113.22a101.94,101.94,0,0,1,7.4,34.66c-19.1,1-33.7,11.44-33.7,24.65a13.47,13.47,0,0,0,1.7,6.93c-7.2-.66-14.3-1.54-21.5-2.53a462.05,462.05,0,0,0-128.8,0,409.92,409.92,0,0,1-118.3,0,439.81,439.81,0,0,0-61.6-4.4V82.3a22.7,22.7,0,0,0,14.8-8.8,22.6,22.6,0,0,0,17.7,9,22.6,22.6,0,0,0,17.7-9,22.6,22.6,0,0,0,17.7,9,22.74,22.74,0,0,0,17.7-9,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,21.88,21.88,0,0,0,35.4,0,22.47,22.47,0,0,0,14.8,8.8V379.71c-10.2.11-20.2.44-30,1.1a16.22,16.22,0,0,0,3.4-10.57C468.7,358.91,460.3,349.23,447.4,343.51Zm-62.5,13.2c7.6-7.15,20.9-12.1,35.7-12.1,23,0,42.4,11.77,42.4,25.63,0,5.84-3.8,9.47-10.6,11.67-6.3.66-12.6,1.32-18.7,2.31l-4.7.66c-2.7.11-5.5.11-8.5.11-4.6,0-8.8-.11-12.7-.22a14.26,14.26,0,0,0,.8-4.84C408.6,369,398.9,360.12,384.9,356.71Zm-1.3-37.08a118.55,118.55,0,0,0,6.6,25.64,38.06,38.06,0,0,0-12.4,10.12,29.42,29.42,0,0,0-3.2-.22,105.4,105.4,0,0,0-8-37.41c-12.6-28.61-4.7-67.56,3.2-91.54C368.9,251.19,369.2,296,383.6,319.63ZM398,140l-7.3-26.52c7.6,9.9,15,20,21.7,30.59,5.9,9.24,13,21.78,16.1,35.76,5.3,23.76-1.1,47.2-8,72.18-5.2,18.81-10.5,38.17-10.4,57.87a138.45,138.45,0,0,0,3.6,28.83A66,66,0,0,0,395.5,343c-8.4-22-9.8-47-2.9-69.76,1.8-5.94,4.2-12,6.5-17.71,2.9-7.38,5.9-14.86,7.9-22.78C414.9,201,405.5,167.13,398,140Zm4.9,239.86c0,4.07-2.9,6.6-8.1,8.14a418.73,418.73,0,0,1-47-.33c-4.4-1.54-6.9-4-6.9-7.81,0-10,14.2-18.38,31-18.38S402.9,369.8,402.9,379.82ZM418.1,332c.5-10.46,4.5-21.13,11.9-31.91,12.8-18.6,19.5-51.17,19.9-96.94,8.7,26.63,17.5,76.8-4.2,119.6-2.2,4.4-3.7,11.23-4,18.82a71.53,71.53,0,0,0-21.2-3.19h-1.1C419,336.14,418.5,334.05,418.1,332Zm77.2-291.8V75.92A17.78,17.78,0,0,1,483,66.46a2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0,16.77,16.77,0,0,1-30.4,0,2.8,2.8,0,0,0-5,0A17.34,17.34,0,0,1,38,76.14a17.34,17.34,0,0,1-15.2-9.68,2.8,2.8,0,0,0-5,0A17.78,17.78,0,0,1,5.5,75.92V40.16ZM6.7,423.72V386a428.26,428.26,0,0,1,60.8,4.4,412.48,412.48,0,0,0,119.8,0A435.71,435.71,0,0,1,251,386a452.6,452.6,0,0,1,63.7,4.4,405.51,405.51,0,0,0,59.9,4.4,405.51,405.51,0,0,0,59.9-4.4,428.26,428.26,0,0,1,60.8-4.4v37.74Z"
                            transform="translate(-1 -33.89)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_CHIMNEY.ref"
                    :data-type="TABLE_DETAILS_TYPE_CHIMNEY.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_CHIMNEY.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 1200" fill="#808081">
                        <rect class="cls-1" width="1200" height="1200" />
                        <path
                            d="M864.61,373.29H820.15l-59.2-71a12.48,12.48,0,0,0-9.7-4.53H449a12.48,12.48,0,0,0-9.69,4.53l-59.2,71H335.61a37.89,37.89,0,0,0-37.79,37.79v25.19A37.92,37.92,0,0,0,323,471.79V801.53H310.42a12.63,12.63,0,0,0-12.6,12.59v75.57a12.63,12.63,0,0,0,12.6,12.59H889.8a12.63,12.63,0,0,0,12.59-12.59V814.12a12.63,12.63,0,0,0-12.59-12.59H877.2V471.78a37.68,37.68,0,0,0,25.19-35.52V411.07a37.89,37.89,0,0,0-37.79-37.79ZM454.89,322.91H745.34l41.94,50.38H413ZM877.21,877.1H323V826.71H877.21Zm-126-75.57H662.08a89.65,89.65,0,0,0,18.64-27.46,92.1,92.1,0,0,0-11.46-93.2l-59.07-76c-4.78-6.17-15.11-6.17-19.9,0l-59.07,76a92.1,92.1,0,0,0-11.46,93.2,87.76,87.76,0,0,0,18.64,27.46H449V549.62H751.27Zm-154.8-.26a23.45,23.45,0,0,1-19.15-14.61,26.94,26.94,0,0,1,3.28-27.45L600.11,734l19.52,25.19a27,27,0,0,1,3.28,27.45c-3.65,8.32-10.58,13.61-19.15,14.61Zm54-25.06a51.78,51.78,0,0,0-11-32.62l-29.48-38c-4.78-6.17-15.11-6.17-19.9,0l-29.47,38a51.72,51.72,0,0,0-10.83,32.62A61.84,61.84,0,0,1,542.8,764a66.77,66.77,0,0,1,8.32-67.76L600.24,633l49.12,63.23a65.8,65.8,0,0,1,1.13,80Zm126,25.32V537a12.63,12.63,0,0,0-12.59-12.6H436.37A12.63,12.63,0,0,0,423.78,537v264.5H348.21V474.05H852V801.53ZM877.2,436.26a12.63,12.63,0,0,1-12.59,12.59h-529A12.63,12.63,0,0,1,323,436.26V411.07a12.62,12.62,0,0,1,12.59-12.59h529a12.62,12.62,0,0,1,12.59,12.59Z"
                            transform="translate(-0.11)" />
                    </svg>
                </div>
            </ShowElementsCategory>
            <ShowElementsCategory :categoryName="$t('labels.booking.seatingPlan.elements.furniture')">
                <div
                    :ref="TABLE_DETAILS_TYPE_COUNTER.ref"
                    :data-type="TABLE_DETAILS_TYPE_COUNTER.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_COUNTER.value)">
                    <svg
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 484.3 253"
                        style="enable-background: new 0 0 484.3 253"
                        xml:space="preserve"
                        fill="#808081">
                        <g><path d="M484.3,253H0.2V0h484.1V253z" /></g>
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_WARDROBE_WINE.ref"
                    :data-type="TABLE_DETAILS_TYPE_WARDROBE_WINE.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_WARDROBE_WINE.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.26 68.55" fill="#808081">
                        <path
                            d="M38.83,32.77c-.47-.43-.45-1.9-.45-2.71l0-5.28a.18.18,0,0,0,.17-.17v-1.2a.17.17,0,0,0-.18-.17h-.05v-.58c0-.07,0-.13-.13-.2H34.84a.26.26,0,0,0-.12.2v.58h-.06a.16.16,0,0,0-.17.17v1.2a.17.17,0,0,0,.17.17l0,5.28c0,.81,0,2.28-.45,2.71-.76.69-2.57,2-2.57,4.25V58.3a9.29,9.29,0,0,0,.2,2.12h0a1.07,1.07,0,0,0,.59.82H40.6a1.07,1.07,0,0,0,.59-.82h0a9.29,9.29,0,0,0,.2-2.12V37C41.4,34.74,39.59,33.46,38.83,32.77Z"
                            transform="translate(-23.87 -15.72)" />
                        <path
                            d="M52.33,32.77c-.47-.43-.45-1.9-.45-2.71l0-5.28a.18.18,0,0,0,.17-.17v-1.2a.17.17,0,0,0-.17-.17h-.06v-.58a.27.27,0,0,0-.12-.2H48.34a.26.26,0,0,0-.12.2v.58h-.06a.17.17,0,0,0-.18.17v1.2a.18.18,0,0,0,.17.17l0,5.28c0,.81,0,2.28-.45,2.71-.75.69-2.56,2-2.56,4.25V58.3a9.29,9.29,0,0,0,.2,2.12h0a1.07,1.07,0,0,0,.59.82h8.18a1.08,1.08,0,0,0,.6-.82h0a9.29,9.29,0,0,0,.2-2.12V37C54.89,34.74,53.08,33.46,52.33,32.77Z"
                            transform="translate(-23.87 -15.72)" />
                        <path
                            d="M65.82,32.77c-.46-.43-.44-1.9-.44-2.71l0-5.28a.18.18,0,0,0,.17-.17v-1.2a.17.17,0,0,0-.18-.17h0v-.58a.31.31,0,0,0-.12-.2H61.83a.29.29,0,0,0-.12.2v.58h-.05a.17.17,0,0,0-.18.17v1.2a.18.18,0,0,0,.17.17l0,5.28c0,.81,0,2.28-.45,2.71-.75.69-2.56,2-2.56,4.25V58.3a9.75,9.75,0,0,0,.19,2.12h0a1.1,1.1,0,0,0,.6.82h8.18a1.1,1.1,0,0,0,.6-.82h0a9.29,9.29,0,0,0,.2-2.12V37C68.39,34.74,66.58,33.46,65.82,32.77Z"
                            transform="translate(-23.87 -15.72)" />
                        <path d="M76.13,68H23.87V15.72H76.13ZM26.42,65.43H73.58V18.27H26.42Z" transform="translate(-23.87 -15.72)" />
                        <rect y="55.92" width="52.26" height="4" />
                        <rect y="61.55" width="7" height="7" />
                        <rect x="45.26" y="61.55" width="7" height="7" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_KITCHEN.ref"
                    :data-type="TABLE_DETAILS_TYPE_KITCHEN.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_KITCHEN.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 75.8" fill="#808081">
                        <path d="M43.4,60a1.5,1.5,0,1,1-1.5-1.5A1.54,1.54,0,0,1,43.4,60" transform="translate(-10 -12.1)" />
                        <path d="M49.1,60a1.5,1.5,0,1,1-1.5-1.5A1.47,1.47,0,0,1,49.1,60" transform="translate(-10 -12.1)" />
                        <path d="M54.9,60a1.5,1.5,0,1,1-1.5-1.5A1.54,1.54,0,0,1,54.9,60" transform="translate(-10 -12.1)" />
                        <path d="M60.6,60a1.5,1.5,0,1,1-1.5-1.5A1.47,1.47,0,0,1,60.6,60" transform="translate(-10 -12.1)" />
                        <path
                            d="M66.4,37.9H34.9V27.4l10.3-8.2V12.1H56.1v7.1l10.3,8.2ZM37,35.9H64.3V32.8H37Zm0-5.3H64.3V28.4L54,20.3V14.2H47.3v6.1L37,28.5Z"
                            transform="translate(-10 -12.1)" />
                        <path
                            d="M86.7,53.9l.1-5.9a5.22,5.22,0,0,0-1.3-3.8A4.77,4.77,0,0,0,82,42.8a5,5,0,0,0-3.5,1.3,5.24,5.24,0,0,0-1.4,3.5h-.4v.7h3.2v-.7h-.4a2.54,2.54,0,0,1,.7-1.8,3,3,0,0,1,3.6,0,3.63,3.63,0,0,1,.7,2.1l-.1,6H59.1v-1H53.4v1H47.7v-1H42v1H11.1v34H90v-34ZM35,85.8H13.1V56H35Zm29,0H37V56H64Zm23.9,0H66.1V56H87.9Z"
                            transform="translate(-10 -12.1)" />
                        <path
                            d="M15.8,39.9V32a.79.79,0,0,0-.8-.8.86.86,0,0,0-.8.8v7.9A5,5,0,1,0,20,44.8,5,5,0,0,0,15.8,39.9ZM15,48.3a3.48,3.48,0,0,1-3.5-3.5A3.54,3.54,0,0,1,15,41.3h0a3.54,3.54,0,0,1,3.5,3.5A3.36,3.36,0,0,1,15,48.3Z"
                            transform="translate(-10 -12.1)" />
                        <path
                            d="M23.7,39.6v-8a.5.5,0,0,0-1,0v8a2.6,2.6,0,0,0-1.4,2.5c0,1.5.9,2.6,1.9,2.6s1.9-1.2,1.9-2.6A2.7,2.7,0,0,0,23.7,39.6Z"
                            transform="translate(-10 -12.1)" />
                        <path
                            d="M28.7,39.2h0V31.7a.5.5,0,0,0-1,0v7.5h0a1.37,1.37,0,0,0-1.4,1.4v3.2a1.37,1.37,0,0,0,1.4,1.4h1a1.37,1.37,0,0,0,1.4-1.4V40.6A1.31,1.31,0,0,0,28.7,39.2ZM27.5,44a.2.2,0,0,1-.4,0V40.8a.2.2,0,0,1,.4,0Zm1,0a.2.2,0,0,1-.4,0V40.8a.2.2,0,0,1,.4,0Zm.9,0a.2.2,0,0,1-.4,0V40.8a.2.2,0,0,1,.4,0Z"
                            transform="translate(-10 -12.1)" />
                        <path
                            d="M79.1,50a7.43,7.43,0,0,1-.8-1.5,7.43,7.43,0,0,1-.8,1.5.93.93,0,0,0,.8,1.5A.91.91,0,0,0,79.1,50Z"
                            transform="translate(-10 -12.1)" />
                        <path d="M69.4,60.2a.68.68,0,0,0-.7.7V82.4a.7.7,0,0,0,1.4,0V60.9A.68.68,0,0,0,69.4,60.2Z" transform="translate(-10 -12.1)" />
                        <path d="M31.9,60.2a.68.68,0,0,0-.7.7V82.4a.7.7,0,1,0,1.4,0V60.9A.68.68,0,0,0,31.9,60.2Z" transform="translate(-10 -12.1)" />
                        <path d="M39.1,84.4H61.9V66.1H39.1ZM40.6,83V77.5H60.4V83ZM60.4,67.6v9.2H40.6V67.6Z" transform="translate(-10 -12.1)" />
                        <path d="M61.2,63.1H39.8a.7.7,0,0,0,0,1.4H61.2a.7.7,0,0,0,0-1.4Z" transform="translate(-10 -12.1)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_BUFFET.ref"
                    :data-type="TABLE_DETAILS_TYPE_BUFFET.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_BUFFET.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.08 78.5" fill="#808081">
                        <path
                            d="M88.42,37.42H78.81a6.24,6.24,0,0,0-.57-5.94,11.53,11.53,0,0,0,.6-1.61h.83a1.93,1.93,0,0,0,0-3.86h-.32A12.59,12.59,0,0,0,68.76,13.89l.58-2.38a.62.62,0,0,0-.11-.53.63.63,0,0,0-.49-.24H64.82a.63.63,0,0,0-.49.24.6.6,0,0,0-.11.53l.58,2.38A12.58,12.58,0,0,0,54.21,26h-.32a1.93,1.93,0,0,0,0,3.86h.83a11.53,11.53,0,0,0,.6,1.61,6.24,6.24,0,0,0-.57,5.94H45.27a6.24,6.24,0,0,0-.57-5.94,11.53,11.53,0,0,0,.6-1.61h.83a1.93,1.93,0,0,0,0-3.86H45.8A12.59,12.59,0,0,0,35.21,13.89l.58-2.38a.62.62,0,0,0-.11-.53.63.63,0,0,0-.49-.24H31.27a.63.63,0,0,0-.49.24.6.6,0,0,0-.11.53l.58,2.38A12.58,12.58,0,0,0,20.66,26h-.32a1.93,1.93,0,0,0,0,3.86h.83a11.53,11.53,0,0,0,.6,1.61,6.24,6.24,0,0,0-.57,5.94H11.59A.62.62,0,0,0,11,38V77a.62.62,0,0,0,1,.47,8.43,8.43,0,0,1,4.71-1.92V88.62a.62.62,0,0,0,.62.62h3.51a.62.62,0,0,0,.6-.45l2.94-10.11A6.79,6.79,0,0,0,33.11,78a8.56,8.56,0,0,1,12.11,0,6.8,6.8,0,0,0,9.59,0,8.56,8.56,0,0,1,12.11,0,6.73,6.73,0,0,0,8.73.69l2.94,10.1a.62.62,0,0,0,.6.45H82.7a.62.62,0,0,0,.62-.62v-13A8.43,8.43,0,0,1,88,77.49a.62.62,0,0,0,1-.47V38A.64.64,0,0,0,88.42,37.42ZM67.94,12l-.42,1.73H66L65.61,12Zm-1.17,3A11.35,11.35,0,0,1,78.1,26H55.44A11.36,11.36,0,0,1,66.77,15ZM53.88,28.64a.68.68,0,0,1,0-1.36H79.67a.68.68,0,1,1,0,1.36Zm3.86,4.52A11.11,11.11,0,0,1,56,29.88H77.54a11.11,11.11,0,0,1-1.73,3.28Zm17.94,4.26H57.87a4.9,4.9,0,0,1,1-3H74.72A4.92,4.92,0,0,1,75.68,37.42Zm-18.32-3a6.07,6.07,0,0,0-.75,3h-.49A5,5,0,0,1,56,32.78a11.86,11.86,0,0,0,1,1.39A.58.58,0,0,0,57.36,34.38Zm19.24-.21a11.86,11.86,0,0,0,1-1.39,5,5,0,0,1-.12,4.64H77a6.17,6.17,0,0,0-.75-3A.63.63,0,0,0,76.6,34.17ZM34.39,12,34,13.73H32.48L32.06,12Zm-1.16,3A11.35,11.35,0,0,1,44.56,26H21.89A11.36,11.36,0,0,1,33.23,15ZM20.33,28.64a.68.68,0,0,1,0-1.36H46.12a.68.68,0,0,1,0,1.36Zm3.86,4.52a11.11,11.11,0,0,1-1.73-3.28H44a11.11,11.11,0,0,1-1.73,3.28Zm17.94,4.26H24.32a4.9,4.9,0,0,1,1-3H41.17A4.92,4.92,0,0,1,42.13,37.42Zm-18.32-3a6.07,6.07,0,0,0-.75,3h-.49a5,5,0,0,1-.12-4.64,11.86,11.86,0,0,0,1,1.39A.58.58,0,0,0,23.81,34.38Zm19.24-.21a11.86,11.86,0,0,0,1-1.39,5,5,0,0,1-.12,4.64H43.4a6.17,6.17,0,0,0-.75-3A.63.63,0,0,0,43.05,34.17ZM20.36,88H17.93V75.53a8.55,8.55,0,0,1,5.38,2.3Zm61.71,0H79.64l-3-10.18a8.59,8.59,0,0,1,5.38-2.3V88ZM87.8,75.78a9.87,9.87,0,0,0-12.2,1.33l0,.06a5.54,5.54,0,0,1-7.77-.06,9.8,9.8,0,0,0-13.86,0,5.54,5.54,0,0,1-7.83,0,9.8,9.8,0,0,0-13.86,0,5.54,5.54,0,0,1-7.83,0h0a9.87,9.87,0,0,0-12.2-1.33V38.67H87.8Z"
                            transform="translate(-10.97 -10.74)" />
                        <path
                            d="M52.52,56.48l.52-.55c2.43.84,5.89-.38,8.59-3.09a10.45,10.45,0,0,0,3.35-7,4.09,4.09,0,0,0-4.32-4.32h0a10.41,10.41,0,0,0-6.94,3.35c-2.71,2.7-3.94,6.16-3.09,8.6l-.64.6-.75-.7.27-3.1a2.54,2.54,0,0,0-.76-2l-7.05-7a1.63,1.63,0,0,0-2.28-.11l0,0A1.49,1.49,0,0,0,39,42.37a1.82,1.82,0,0,0,.52,1.12L44.8,48.8a.28.28,0,0,1,.09.29.27.27,0,0,1-.28-.09L39.3,43.68a1.54,1.54,0,1,0-2.17,2.17l5.32,5.32a.3.3,0,0,1,.09.28.25.25,0,0,1-.28-.09L36.94,46a1.56,1.56,0,1,0-2.2,2.2l7,7a2.54,2.54,0,0,0,2,.76l3.11-.27.62.66L36,67.09a3.15,3.15,0,0,0-1,2.2,2.19,2.19,0,0,0,.62,1.6,2.24,2.24,0,0,0,1.59.64h.05a3,3,0,0,0,2.16-1L50,59.18,61.36,71.34a3.13,3.13,0,0,0,2.17,1h0a2.19,2.19,0,0,0,1.58-.63,2.22,2.22,0,0,0,.63-1.63,3.09,3.09,0,0,0-1-2.17Zm-.61-3.08c-.93-1.95.2-5.15,2.67-7.61a9.32,9.32,0,0,1,6.06-3h0a3.11,3.11,0,0,1,2.26.83,3.06,3.06,0,0,1,.82,2.25,9.35,9.35,0,0,1-3,6.08c-2.47,2.47-5.66,3.59-7.61,2.67a.61.61,0,0,0-.72.14l-.81.86L50.87,55l.89-.83A.61.61,0,0,0,51.91,53.4ZM38.53,69.66a1.86,1.86,0,0,1-1.28.62.93.93,0,0,1-.73-.27,1,1,0,0,1-.26-.7A2,2,0,0,1,36.88,68L48.31,57.34l.85.91Zm25.75,1.17a1,1,0,0,1-.73.27,1.86,1.86,0,0,1-1.28-.62L47.56,54.7a.61.61,0,0,0-.45-.2h0l-3.4.3a1.19,1.19,0,0,1-1-.4l-7.05-7a.4.4,0,0,1-.08-.55c.1-.1.34-.08.52.11l5.32,5.32a1.44,1.44,0,0,0,2,.09,1.33,1.33,0,0,0,.38-.94,1.55,1.55,0,0,0-.47-1.1L38,45c-.18-.18-.21-.43-.11-.52s.34-.08.52.11l5.32,5.32a1.38,1.38,0,1,0,2-1.95l-5.31-5.31a.47.47,0,0,1-.16-.33.26.26,0,0,1,.06-.2l0,0c.1-.1.34-.08.52.11l7.05,7a1.28,1.28,0,0,1,.4,1l-.3,3.4a.62.62,0,0,0,.2.51L64,68.83a1.86,1.86,0,0,1,.62,1.28A1.12,1.12,0,0,1,64.28,70.83Z"
                            transform="translate(-10.97 -10.74)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_FRIDGE.ref"
                    :data-type="TABLE_DETAILS_TYPE_FRIDGE.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_FRIDGE.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="#808081">
                        <rect class="cls-1" width="100" height="100" />
                        <path
                            d="M71.7,98H29.48a1.63,1.63,0,0,1-1.62-1.62h0V18.45a1.62,1.62,0,0,1,3.23,0V94.77h39V53.05l-39,.17V51.75h39V35.86l-39-.17V34.16l39,0V18.3a1.62,1.62,0,1,1,3.23-.25,1,1,0,0,1,0,.25V96.38A1.62,1.62,0,0,1,71.7,98Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M71.77,19.45H29.41a1.55,1.55,0,0,1-1.55-1.55h0V3.57A1.57,1.57,0,0,1,29.41,2H71.77a1.56,1.56,0,0,1,1.55,1.57h0V17.89a1.54,1.54,0,0,1-1.54,1.56ZM31,16.32H70.21V5.13H31Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M71.77,98H29.41a1.57,1.57,0,0,1-1.55-1.57h0V75.06A1.56,1.56,0,0,1,29.4,73.5H71.77a1.54,1.54,0,0,1,1.55,1.55h0V96.43A1.56,1.56,0,0,1,71.77,98ZM31,94.87H70.21V76.63H31Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M55,81.68H46.15a1.26,1.26,0,0,1-.22-2.51.81.81,0,0,1,.22,0H55a1.26,1.26,0,1,1,.23,2.51Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M40.35,34.14V30.59a3.73,3.73,0,0,1,.54-1.87A4.9,4.9,0,0,0,41.75,26V25h.78v1a4.78,4.78,0,0,0,.86,2.74,3,3,0,0,1,.55,1.87v3.55H45.5V30.67a4.61,4.61,0,0,0-.86-2.73,3.2,3.2,0,0,1-.54-1.88v-1.8a.73.73,0,0,0-.67-.78H41a.73.73,0,0,0-.78.68v1.9a3.7,3.7,0,0,1-.55,1.88,5.12,5.12,0,0,0-.86,2.73v3.47Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M34.34,34.14V30.59a3.84,3.84,0,0,1,.55-1.87A4.9,4.9,0,0,0,35.75,26V25h.78v1a4.78,4.78,0,0,0,.86,2.74,3,3,0,0,1,.55,1.87v3.55H39.5V30.67a4.61,4.61,0,0,0-.86-2.73,3.14,3.14,0,0,1-.55-1.88v-1.8a.73.73,0,0,0-.67-.78H35a.73.73,0,0,0-.78.68v1.9a3.7,3.7,0,0,1-.55,1.88,4.9,4.9,0,0,0-.86,2.73v3.47Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M52,34.14V30.59a3.84,3.84,0,0,1,.55-1.87A4.9,4.9,0,0,0,53.39,26V25h.78v1A4.78,4.78,0,0,0,55,28.74a3.06,3.06,0,0,1,.56,1.85v3.55h1.56V30.67a4.61,4.61,0,0,0-.86-2.73,3.2,3.2,0,0,1-.54-1.88v-1.8a.73.73,0,0,0-.69-.78H52.59a.73.73,0,0,0-.78.68v1.9a3.7,3.7,0,0,1-.55,1.88,4.9,4.9,0,0,0-.86,2.73v3.47Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M46,34.14V30.59a3.84,3.84,0,0,1,.55-1.87A4.9,4.9,0,0,0,47.39,26V25h.78v1A4.78,4.78,0,0,0,49,28.74a3.06,3.06,0,0,1,.56,1.85v3.55h1.56V30.67a4.61,4.61,0,0,0-.86-2.73,3.14,3.14,0,0,1-.55-1.88v-1.8a.73.73,0,0,0-.67-.78H46.59a.74.74,0,0,0-.79.69v1.89a3.79,3.79,0,0,1-.54,1.88,4.9,4.9,0,0,0-.86,2.73v3.47Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M63.59,34.14V30.59a3.84,3.84,0,0,1,.55-1.87A4.93,4.93,0,0,0,65,26V25h.78v1a4.78,4.78,0,0,0,.86,2.74,3,3,0,0,1,.55,1.87v3.55h1.56V30.67a4.61,4.61,0,0,0-.86-2.73,3.14,3.14,0,0,1-.55-1.88v-1.8a.73.73,0,0,0-.67-.78H64.25a.73.73,0,0,0-.78.68v1.9a3.7,3.7,0,0,1-.55,1.88,4.9,4.9,0,0,0-.86,2.73v3.47Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M57.59,34.14V30.59a3.64,3.64,0,0,1,.55-1.87A4.93,4.93,0,0,0,59,26V25h.78v1a4.78,4.78,0,0,0,.86,2.74,3,3,0,0,1,.54,1.87v3.55h1.57V30.67a4.75,4.75,0,0,0-.86-2.73,3.14,3.14,0,0,1-.55-1.88v-1.8a.73.73,0,0,0-.67-.78H58.24a.75.75,0,0,0-.78.7v1.88a3.79,3.79,0,0,1-.54,1.88,4.9,4.9,0,0,0-.86,2.73v3.47Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M40,73.66a.38.38,0,0,0,.39-.39V70.12a3.79,3.79,0,0,1,.54-1.88,4.9,4.9,0,0,0,.86-2.73v-.63a.41.41,0,0,1,.39-.39h0a.38.38,0,0,1,.39.39v.63a4.75,4.75,0,0,0,.86,2.73,3,3,0,0,1,.55,1.88v3.15a.39.39,0,0,0,.39.39h.78a.37.37,0,0,0,.39-.37V70.2a4.64,4.64,0,0,0-.86-2.74,3.2,3.2,0,0,1-.54-1.88v-1.4A1.17,1.17,0,0,0,42.94,63H41.36a1.17,1.17,0,0,0-1.17,1.17v1.4a3.7,3.7,0,0,1-.55,1.88,5,5,0,0,0-.86,2.74v3.07a.39.39,0,0,0,.39.39Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M34,73.66a.37.37,0,0,0,.39-.37V70.12a3.91,3.91,0,0,1,.55-1.88,4.9,4.9,0,0,0,.86-2.73v-.63a.39.39,0,0,1,.39-.39h0a.38.38,0,0,1,.39.39v.63a4.75,4.75,0,0,0,.86,2.73,3.07,3.07,0,0,1,.55,1.88v3.15a.39.39,0,0,0,.37.39h.8a.37.37,0,0,0,.39-.37V70.2a4.64,4.64,0,0,0-.86-2.74,3.14,3.14,0,0,1-.55-1.88v-1.4A1.17,1.17,0,0,0,36.93,63H35.36a1.17,1.17,0,0,0-1.17,1.17v1.4a3.7,3.7,0,0,1-.55,1.88,5,5,0,0,0-.86,2.74v3.07a.39.39,0,0,0,.39.39Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M51.59,73.66a.37.37,0,0,0,.39-.37V70.12a3.91,3.91,0,0,1,.55-1.88,4.9,4.9,0,0,0,.86-2.73v-.63a.41.41,0,0,1,.39-.39h0a.38.38,0,0,1,.39.39v.63A4.75,4.75,0,0,0,55,68.24a3.08,3.08,0,0,1,.56,1.88v3.15a.39.39,0,0,0,.37.39h.8a.37.37,0,0,0,.39-.37V70.2a4.64,4.64,0,0,0-.86-2.74,3.2,3.2,0,0,1-.54-1.88v-1.4A1.17,1.17,0,0,0,54.59,63H53a1.17,1.17,0,0,0-1.17,1.17v1.4a3.7,3.7,0,0,1-.55,1.88,5,5,0,0,0-.86,2.74v3.07a.39.39,0,0,0,.39.39Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M45.59,73.66a.37.37,0,0,0,.39-.37V70.12a3.91,3.91,0,0,1,.55-1.88,4.9,4.9,0,0,0,.86-2.73v-.63a.39.39,0,0,1,.39-.39h0a.4.4,0,0,1,.39.39v.63A4.75,4.75,0,0,0,49,68.24a3.08,3.08,0,0,1,.56,1.88v3.15a.39.39,0,0,0,.37.39h.8a.38.38,0,0,0,.39-.39V70.2a4.64,4.64,0,0,0-.86-2.74,3.14,3.14,0,0,1-.55-1.88v-1.4A1.17,1.17,0,0,0,48.59,63H47a1.17,1.17,0,0,0-1.18,1.16h0v1.4a3.79,3.79,0,0,1-.54,1.88,5,5,0,0,0-.86,2.74v3.07a.39.39,0,0,0,.37.39h.8Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M63.23,73.66a.37.37,0,0,0,.39-.37V70.12a3.91,3.91,0,0,1,.55-1.88A4.9,4.9,0,0,0,65,65.51v-.63a.39.39,0,0,1,.39-.39h0a.38.38,0,0,1,.39.39v.63a4.75,4.75,0,0,0,.86,2.73,3.07,3.07,0,0,1,.55,1.88v3.15a.39.39,0,0,0,.37.39h.8a.37.37,0,0,0,.39-.37V70.2a4.64,4.64,0,0,0-.86-2.74,3.14,3.14,0,0,1-.55-1.88v-1.4A1.17,1.17,0,0,0,66.21,63H64.64a1.17,1.17,0,0,0-1.17,1.17v1.4a3.7,3.7,0,0,1-.55,1.88,5,5,0,0,0-.86,2.74v3.07a.39.39,0,0,0,.37.39h.8Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M57.23,73.66a.38.38,0,0,0,.39-.39V70.12a3.7,3.7,0,0,1,.55-1.88A5,5,0,0,0,59,65.51v-.63a.39.39,0,0,1,.39-.39h0a.4.4,0,0,1,.39.39v.63a4.75,4.75,0,0,0,.86,2.73,3.07,3.07,0,0,1,.54,1.88v3.15a.39.39,0,0,0,.39.39h.79a.38.38,0,0,0,.39-.39V70.2a4.78,4.78,0,0,0-.86-2.74,3.14,3.14,0,0,1-.55-1.88v-1.4A1.17,1.17,0,0,0,60.21,63H58.64a1.17,1.17,0,0,0-1.18,1.16h0v1.4a3.79,3.79,0,0,1-.54,1.88,5,5,0,0,0-.86,2.74v3.07a.39.39,0,0,0,.37.39h.8Z"
                            transform="translate(-0.59 0)" />
                        <rect x="28.92" y="38.33" width="40.97" height="2.31" />
                        <path
                            d="M36.72,41.23v2.59a2.42,2.42,0,0,0-1.61,2.26v4.05a1.62,1.62,0,0,0,1.61,1.62h1.62A1.63,1.63,0,0,0,40,50.13V46.08a2.34,2.34,0,0,0-1.62-2.26V41.23Zm1.62,8.9H36.72V46.08a.81.81,0,1,1,1.62,0Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M43.2,41.23v2.59a2.43,2.43,0,0,0-1.61,2.26v4.05a1.64,1.64,0,0,0,1.62,1.62h1.62a1.62,1.62,0,0,0,1.61-1.62V46.08a2.33,2.33,0,0,0-1.61-2.26V41.23Zm1.62,8.9H43.2V46.08a.81.81,0,1,1,1.62,0Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M51.29,43.82V41.23H49.67v2.59a2.44,2.44,0,0,0-1.62,2.26v4.05a1.64,1.64,0,0,0,1.62,1.62h1.62a1.63,1.63,0,0,0,1.62-1.62V46.08A2.34,2.34,0,0,0,51.29,43.82Zm0,6.31H49.67V46.08a.81.81,0,1,1,1.62,0Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M56.43,41.23v2.59a2.44,2.44,0,0,0-1.62,2.26v4.05a1.64,1.64,0,0,0,1.62,1.62h1.62a1.63,1.63,0,0,0,1.62-1.62V46.08a2.34,2.34,0,0,0-1.62-2.26V41.23Zm1.62,8.9H56.43V46.08a.81.81,0,0,1,1.62,0Z"
                            transform="translate(-0.59 0)" />
                        <path
                            d="M62.9,41.23v2.59a2.44,2.44,0,0,0-1.62,2.26v4.05a1.64,1.64,0,0,0,1.62,1.62h1.62a1.63,1.63,0,0,0,1.62-1.62V46.08a2.34,2.34,0,0,0-1.62-2.26V41.23Zm1.62,8.9H62.9V46.08a.81.81,0,1,1,1.62,0Z"
                            transform="translate(-0.59 0)" />
                    </svg>
                </div>
            </ShowElementsCategory>
            <ShowElementsCategory :categoryName="$t('labels.booking.seatingPlan.elements.diverse')">
                <div
                    :ref="TABLE_DETAILS_TYPE_CAR_PARK.ref"
                    :data-type="TABLE_DETAILS_TYPE_CAR_PARK.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_CAR_PARK.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 94.9 94.9" fill="#808081">
                        <path
                            d="M84.3,2.5H15.7A13.19,13.19,0,0,0,2.5,15.7V84.2A13.19,13.19,0,0,0,15.7,97.4H84.2A13.19,13.19,0,0,0,97.4,84.2V15.7A13,13,0,0,0,84.3,2.5ZM52.1,58H42.9V80.5H32.3v-61H52.1a19.25,19.25,0,1,1,0,38.5Z"
                            transform="translate(-2.5 -2.5)" />
                        <path d="M52.1,30H42.9V47.4h9.2a8.7,8.7,0,0,0,0-17.4Z" transform="translate(-2.5 -2.5)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_TOILET.ref"
                    :data-type="TABLE_DETAILS_TYPE_TOILET.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_TOILET.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.26 96.26" fill="#808081">
                        <path
                            d="M50.35,98.41A48.13,48.13,0,1,1,98.49,50.28,48.18,48.18,0,0,1,50.35,98.41Zm0-94.76A46.63,46.63,0,1,0,97,50.28,46.68,46.68,0,0,0,50.35,3.65Z"
                            transform="translate(-2.23 -2.15)" />
                        <path
                            d="M30.5,34.85a5.42,5.42,0,1,1,5.41-5.42A5.42,5.42,0,0,1,30.5,34.85Zm0-9.33a3.92,3.92,0,1,0,3.91,3.91A3.92,3.92,0,0,0,30.5,25.52Z"
                            transform="translate(-2.23 -2.15)" />
                        <path
                            d="M70.43,34.85a5.42,5.42,0,1,1,5.42-5.42A5.42,5.42,0,0,1,70.43,34.85Zm0-9.33a3.92,3.92,0,1,0,3.92,3.91A3.92,3.92,0,0,0,70.43,25.52Z"
                            transform="translate(-2.23 -2.15)" />
                        <path
                            d="M33.76,76.54a3.06,3.06,0,0,1-3.06-3.06V56.1a.31.31,0,0,0-.31-.31.3.3,0,0,0-.3.31V73.48a3.07,3.07,0,0,1-6.13,0v-26a25.22,25.22,0,0,0-1.07,7.29,2.72,2.72,0,1,1-5.44,0A30.71,30.71,0,0,1,23.09,37a2.71,2.71,0,0,1,2.22-1.16H35.47A2.73,2.73,0,0,1,37.7,37a30.76,30.76,0,0,1,5.64,17.75,2.72,2.72,0,1,1-5.44,0,25.58,25.58,0,0,0-1.08-7.29v26A3.06,3.06,0,0,1,33.76,76.54ZM30.39,54.29A1.81,1.81,0,0,1,32.2,56.1V73.48a1.56,1.56,0,0,0,3.12,0V45A1.07,1.07,0,0,1,36,44a1,1,0,0,1,1.42.58,27,27,0,0,1,2,10.16A1.23,1.23,0,0,0,40.62,56a1.2,1.2,0,0,0,.86-.36,1.23,1.23,0,0,0,.36-.87,29.34,29.34,0,0,0-5.37-16.88,1.21,1.21,0,0,0-1-.52H25.31a1.22,1.22,0,0,0-1,.52A29.24,29.24,0,0,0,19,54.72a1.22,1.22,0,1,0,2.44,0,26.65,26.65,0,0,1,2-10.17,1.07,1.07,0,0,1,2.06.41V73.48a1.57,1.57,0,0,0,3.13,0V56.1A1.81,1.81,0,0,1,30.39,54.29Z"
                            transform="translate(-2.23 -2.15)" />
                        <path
                            d="M73.69,76.54a3.06,3.06,0,0,1-3.06-3.06V56.1a.31.31,0,1,0-.62,0V73.48a3.06,3.06,0,1,1-6.11,0v-26a24.89,24.89,0,0,0-1.08,7.29,2.73,2.73,0,1,1-5.45,0A30.77,30.77,0,0,1,63,37a2.68,2.68,0,0,1,2.22-1.16H75.4A2.71,2.71,0,0,1,77.63,37a30.71,30.71,0,0,1,5.64,17.74,2.72,2.72,0,1,1-5.44,0,25.58,25.58,0,0,0-1.08-7.29v26A3.06,3.06,0,0,1,73.69,76.54ZM70.32,54.29a1.81,1.81,0,0,1,1.81,1.81V73.48a1.56,1.56,0,1,0,3.12,0V45a1.08,1.08,0,0,1,.64-1,1.06,1.06,0,0,1,1.43.58,27,27,0,0,1,2,10.16A1.23,1.23,0,0,0,80.55,56a1.2,1.2,0,0,0,.86-.36,1.23,1.23,0,0,0,.36-.87A29.25,29.25,0,0,0,76.4,37.84a1.21,1.21,0,0,0-1-.52H65.24a1.19,1.19,0,0,0-1,.52,29.25,29.25,0,0,0-5.37,16.88,1.22,1.22,0,1,0,2.44,0,26.84,26.84,0,0,1,2-10.17,1.09,1.09,0,0,1,1-.67A1.08,1.08,0,0,1,65.4,45V73.48a1.56,1.56,0,0,0,3.12,0V56.1A1.79,1.79,0,0,1,70.32,54.29Z"
                            transform="translate(-2.23 -2.15)" />
                        <rect x="46.93" y="14.5" width="2.4" height="67.27" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_POOL.ref"
                    :data-type="TABLE_DETAILS_TYPE_POOL.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_POOL.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.01 55" fill="#808081">
                        <path
                            d="M3,22H27.23l-.29.48a6.67,6.67,0,0,0-.94,3.4V41a1,1,0,0,0,2,0V37H39v4a1,1,0,0,0,2,0V25.88a4.6,4.6,0,0,1,.66-2.37l.9-1.51H61a1,1,0,0,0,0-2H56V8.45A3.5,3.5,0,0,0,52.46,5a3.55,3.55,0,0,0-3.05,1.71L43,17.38V8.45A3.5,3.5,0,0,0,39.46,5a3.55,3.55,0,0,0-3.05,1.71L28.43,20H3a1,1,0,0,0,0,2Zm36.94.48a6.67,6.67,0,0,0-.94,3.4V28H28V25.88a4.6,4.6,0,0,1,.66-2.37l.9-1.51H40.23ZM28,35V30H39v5ZM51.12,7.74A1.58,1.58,0,0,1,52.46,7,1.51,1.51,0,0,1,54,8.45V20H43.76Zm-13,0A1.58,1.58,0,0,1,39.46,7,1.51,1.51,0,0,1,41,8.45V20H30.76Z"
                            transform="translate(-2 -5)" />
                        <path
                            d="M60.3,45.26a4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0,4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0,4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0,4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0L2.3,47.67a1,1,0,1,0,1.4,1.44L6.18,46.7a4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0,4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0,4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0,4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0,1,1,0,1,0-1.4-1.44Z"
                            transform="translate(-2 -5)" />
                        <path
                            d="M60.3,35.57a4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0,4,4,0,0,1-2.49,1.1A1,1,0,0,0,43,37.74h0a1,1,0,0,0,1.07.93h0A6,6,0,0,0,47.82,37a4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0,1,1,0,1,0-1.4-1.43Z"
                            transform="translate(-2 -5)" />
                        <path
                            d="M18.66,35.57a4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0L2.3,38a1,1,0,0,0,1.41,1.42h0L6.18,37a4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0A4,4,0,0,1,23,35.89a1,1,0,0,0,.06-2A6,6,0,0,0,18.66,35.57Z"
                            transform="translate(-2 -5)" />
                        <path
                            d="M60.3,55.87a4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0,4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0,4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0,4,4,0,0,1-5.54,0,6,6,0,0,0-8.34,0L2.3,58.28a1,1,0,1,0,1.4,1.44l2.48-2.41a4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0,4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0,4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0,4,4,0,0,1,5.54,0,6,6,0,0,0,8.34,0,1,1,0,1,0-1.4-1.44Z"
                            transform="translate(-2 -5)" />
                    </svg>
                </div>
                <div
                    :ref="TABLE_DETAILS_TYPE_BEACH.ref"
                    :data-type="TABLE_DETAILS_TYPE_BEACH.value"
                    data-seats="0"
                    :data-size="TABLE_SIZE_SMALL.value"
                    class="seating-plan-table d-inline-block p-1"
                    v-tooltip="getTooltipAddElement(TABLE_DETAILS_TYPE_BEACH.value)">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65.14 53.36" fill="#808081">
                        <path
                            d="M82,75.57H74.35c0-1.31-.18-4.78-.61-9.23h0c-.17-1.79-.39-3.73-.67-5.76h0c-.29-2.06-.63-4.2-1.06-6.34A.65.65,0,0,0,72,54a.54.54,0,0,0-.15-.38c-.46-2.22-1-4.42-1.63-6.51V47a43.2,43.2,0,0,0-1.77-4.93h.22a24.68,24.68,0,0,1,4.55,8.55h0v.16a.52.52,0,0,0,.1.11h0a.54.54,0,0,0,.34.12.54.54,0,0,0,.38-.15,4.89,4.89,0,0,0,1-6.72,39.5,39.5,0,0,0-3.86-4.6,2.3,2.3,0,0,0-.91-1.74,25.34,25.34,0,0,1,7,3.86,38.93,38.93,0,0,1,4.09,3.5.52.52,0,0,0,.41.18H82a.56.56,0,0,0,.39-.46,7.78,7.78,0,0,0-4.25-8.11,22.44,22.44,0,0,0-5-1.77c4.36-.46,6.33,1.13,6.34,1.14l.09.06h.06a.55.55,0,0,0,.25.07h0a.58.58,0,0,0,.57-.57h0a.54.54,0,0,0,0-.18h0v-.09A6.68,6.68,0,0,0,73.12,31a16.65,16.65,0,0,0-3.59,1c3.11-3,5.8-2.47,5.93-2.45a.57.57,0,0,0,.48-1,6.42,6.42,0,0,0-8,.06,13.42,13.42,0,0,0-2.35,2.53,6.6,6.6,0,0,1,4.27-6.68.57.57,0,0,0,.39-.63.6.6,0,0,0-.57-.49,7.47,7.47,0,0,0-7.45,7.47,7.37,7.37,0,0,0,.05.82c.06.53.14,1,.22,1.49a14.7,14.7,0,0,0-5.74-3.21A18.23,18.23,0,0,0,42.2,31.42l-2.37,1.35a.57.57,0,0,0-.26.7.58.58,0,0,0,.65.36c.12,0,10.47-2,15.61-.31a18,18,0,0,0-15.3,10.14c-2.37,4.72-2.35,4.73-1.88,5.09a.61.61,0,0,0,.35.11.67.67,0,0,0,.42-.16l.35-.36C45,42.87,50.06,39.3,54.43,38a18.23,18.23,0,0,0-7.3,14.93V54.5a.59.59,0,0,0,.47.57h.11a.57.57,0,0,0,.53-.36c.06-.14,5.49-13.5,11.83-16.4a2.58,2.58,0,0,0,.38.69A2.25,2.25,0,0,0,60,40.08a27.66,27.66,0,0,0-3,7.37,11.81,11.81,0,0,0,2.61,10.46.55.55,0,0,0,.43.2h.21a.57.57,0,0,0,.37-.56c0-.09-.36-9.3,1.1-14.73a2.6,2.6,0,0,0,.56.07,2.4,2.4,0,0,0,2-1c.24,1.51.52,3.28.8,5.25a.54.54,0,0,0,0,.18.58.58,0,0,0,.11.31c1.13,8.15,2.27,19.46,1.43,28H55.36a1.52,1.52,0,0,0-.16-1.18L53,70.59h5.19a2.42,2.42,0,0,0,0-4.84H28.27a1.49,1.49,0,0,1-1.06-.43L21.52,59.9a2.5,2.5,0,0,0-3.43.06,2.43,2.43,0,0,0,.09,3.43l6.15,5.88a4.8,4.8,0,0,0,3.31,1.32h3.62l-2.18,3.78a1.54,1.54,0,0,0-.16,1.17H27.31a.58.58,0,0,0,0,1.15H82a.58.58,0,0,0,.57-.57h0A.55.55,0,0,0,82,75.57ZM69.27,47.82c.53,1.8,1,3.68,1.39,5.58H67c-.22-2-.46-3.84-.7-5.58Zm1.63,6.73c.35,1.81.66,3.63.91,5.4H67.64c-.13-1.83-.3-3.64-.49-5.4ZM68,66.9h4.64c.39,4.15.53,7.39.57,8.66H67.73A73.63,73.63,0,0,0,68,66.9Zm0-1.15c0-1.54-.13-3.1-.23-4.65H72c.22,1.62.4,3.18.55,4.65Zm-5.85-27h0a1.42,1.42,0,0,1-.35-.11h0a.6.6,0,0,0-.21-.14h0a1.27,1.27,0,0,1-.42-.93,1.23,1.23,0,0,1,1.23-1.23,1.17,1.17,0,0,1,.76.28,1.1,1.1,0,0,1,.36.44,1.59,1.59,0,0,0,.06.3v.26a1.26,1.26,0,0,1-.51,1,1.39,1.39,0,0,1-1,.11Zm8.1,1.12A1.23,1.23,0,1,1,68.09,39h.07a1.7,1.7,0,0,0,.39-.27h.23a1.25,1.25,0,0,1,1.46,1,1.23,1.23,0,0,1,0,.2.22.22,0,0,0-.05-.08Zm-4-2c-.13-.2-.26-.38-.39-.56a1.21,1.21,0,0,1-.06-.38,1.24,1.24,0,0,1,.12-.53,1.17,1.17,0,0,1,.48-.53c.35,0,.69-.08,1-.1a1.22,1.22,0,0,1,.71,1.57,1.51,1.51,0,0,1-.11.22l-.08.1-.08.05a2.33,2.33,0,0,0-.38.26l-.07.05a1.26,1.26,0,0,1-1.2-.2Zm7.88,11.66A26.84,26.84,0,0,0,70,41.93a2.53,2.53,0,0,0,1-1,38.78,38.78,0,0,1,3.24,4,3.71,3.71,0,0,1-.17,4.55Zm7.35-5.89q-1.59-1.45-3.31-2.74a24,24,0,0,0-8.81-4.44,2.4,2.4,0,0,0-.28-.73,20.17,20.17,0,0,1,8.71,2.2,6.62,6.62,0,0,1,3.63,5.66Zm-8.2-11.53a5.43,5.43,0,0,1,5.17,2.27c-1.66-.6-4.56-1.08-8.9.14h-.06c-.67,0-1.33,0-2,0a2.41,2.41,0,0,0-.71-.05L67.7,34A18.1,18.1,0,0,1,73.28,32.11Zm-4.57-2.68a5.19,5.19,0,0,1,4.66-1c-1.67.37-4,1.49-6.34,4.59-.73.37-1.39.75-1.94,1.09A14.88,14.88,0,0,1,68.71,29.43ZM65,26.53a6.26,6.26,0,0,1,1.55-1.26,8,8,0,0,0-2,7.16.5.5,0,0,0,0,.13c-.3.51-.56,1-.76,1.41a21.39,21.39,0,0,1-.43-2.52A6.3,6.3,0,0,1,65,26.53ZM43.2,32.18A17,17,0,0,1,56.43,31a12.38,12.38,0,0,1,5.9,3.59,17.11,17.11,0,0,0-4-.93C55.32,31,47.61,31.59,43.2,32.18ZM40.83,45.63l.73-1.45a16.88,16.88,0,0,1,14.67-9.53,16,16,0,0,1,4.51.59,12.72,12.72,0,0,0-3.46,1.06C52.55,36.59,46.78,39.87,40.83,45.63Zm7.48,6.1a16.9,16.9,0,0,1,7.53-13.32,13.21,13.21,0,0,1,4.32-1.88,2.1,2.1,0,0,0-.19.6C54.78,39.22,50.32,47.47,48.31,51.73Zm11.14,4a10.71,10.71,0,0,1-1.58-5.59,10.31,10.31,0,0,1,.28-2.41,26.36,26.36,0,0,1,2.2-5.9,2.23,2.23,0,0,0,.35.4c-1.18,4.14-1.28,10.4-1.25,13.49Zm2.86-14a1.25,1.25,0,0,1-1.24-1.25v-.09h0a1.17,1.17,0,0,1,.25-.62h.17l.17.06a2.24,2.24,0,0,0,.57.08h.1a2.8,2.8,0,0,0,.58-.09l.16,0h.17a1.22,1.22,0,0,1-.16,1.72,1.16,1.16,0,0,1-.84.28Zm2.51-3.83a2.17,2.17,0,0,0,.43.61h0a33.5,33.5,0,0,1,3.66,8.17H66.17c-.57-4-1.12-7.2-1.44-8.93ZM54.22,75a.42.42,0,0,1,0,.31.41.41,0,0,1-.5.29h0a.39.39,0,0,1-.25-.2L50.7,70.64h1Zm-4.81-4.36.67,1.16H34.21l.67-1.16ZM25.12,68.43,19,62.56a1.25,1.25,0,0,1-.4-.89,1.32,1.32,0,0,1,.36-.91,1.27,1.27,0,0,1,.92-.39,1.23,1.23,0,0,1,.87.36l5.7,5.43a2.66,2.66,0,0,0,1.85.74h30a1.27,1.27,0,1,1,0,2.54H27.64A3.64,3.64,0,0,1,25.12,68.43Zm5,6.52,2.51-4.36h1L30.8,75.35a.43.43,0,0,1-.26.2.35.35,0,0,1-.5-.26.33.33,0,0,1,0-.29Zm3.46-2H50.75l1.54,2.67H32Z"
                            transform="translate(-17.43 -23.33)" />
                    </svg>
                </div>
            </ShowElementsCategory>
        </div>
        <div class="border-bottom-light plan-tools pt-2 pb-2" v-if="has_right_to_update_seatingplan">
            <strong>{{ $tl("labels.booking.seatingPlan.tools.title") }}</strong>
            <div class="row m-0">
                <div class="col-12 ps-1 pe-1 pt-1">
                    <!-- move -->
                    <button
                        type="button"
                        class="btn d-inline-block"
                        :class="{ active: mode === 'move' }"
                        @click="setMoveMode()"
                        v-tooltip="getTooltip($t('labels.booking.seatingPlan.tools.move'))">
                        <feather type="move" />
                    </button>
                    <!-- select -->
                    <button
                        type="button"
                        class="btn d-inline-block"
                        :class="{ active: mode === 'select' }"
                        @click="setSelectMode()"
                        v-tooltip="getTooltip($t('labels.booking.seatingPlan.tools.select'))">
                        <feather type="maximize" />
                    </button>
                    <div class="v-separator d-inline"></div>
                    <!-- clockwise -->
                    <button
                        type="button"
                        class="btn d-inline-block"
                        @click="rotate('cw')"
                        v-tooltip="getTooltip($t('labels.booking.seatingPlan.tools.rotateCw'))">
                        <feather type="rotate-cw" />
                    </button>
                    <!-- counter clockwise -->
                    <button
                        type="button"
                        class="btn d-inline-block"
                        @click="rotate('ccw')"
                        v-tooltip="getTooltip($t('labels.booking.seatingPlan.tools.rotateCcw'))">
                        <feather type="rotate-ccw" />
                    </button>
                    <!-- duplicate -->
                    <button
                        type="button"
                        class="btn d-inline-block"
                        @click="$emit('duplicate')"
                        v-tooltip="getTooltip($t('labels.booking.seatingPlan.tools.duplicate'))">
                        <feather type="copy" />
                    </button>
                    <!-- trash -->
                    <button
                        type="button"
                        class="btn d-inline-block"
                        @click="remove(false)"
                        v-tooltip="getTooltip($t('labels.booking.seatingPlan.tools.delete'))">
                        <feather type="trash-2" />
                    </button>
                    <!-- Width + -->
                    <button
                        type="button"
                        v-if="canChangeSelectedTablesSize"
                        class="btn d-inline-block"
                        @click="$emit('changeSize', 'higher')"
                        v-tooltip="getTooltip($t('labels.booking.seatingPlan.tools.width-plus'))">
                        <feather type="plus" />
                    </button>
                    <!-- Width - -->
                    <button
                        type="button"
                        v-if="canChangeSelectedTablesSize"
                        class="btn d-inline-block"
                        @click="$emit('changeSize', 'smaller')"
                        v-tooltip="getTooltip($t('labels.booking.seatingPlan.tools.width-minus'))">
                        <feather type="minus" />
                    </button>
                </div>
            </div>
        </div>
        <div class="border-bottom-light pt-3 pb-3" v-if="selectedTables && selectedTables.length === 0">
            <strong>{{ $tl("labels.booking.seatingPlan.recap") }}</strong>
            <div class="row pt-3 pb-1">
                <div class="col-8 pt-1">
                    {{ $tl("labels.booking.seatingPlan.nbTables") }}
                </div>
                <div class="col-4 pt-1 text-end">
                    {{ tablesCountInAllRooms }}
                </div>
            </div>
            <div class="row pb-1">
                <div class="col-8 pt-1">
                    {{ $tl("labels.booking.seatingPlan.nbSeats") }}
                </div>
                <div class="col-4 pt-1 text-end">
                    {{ seatsCountInAllRooms }}
                </div>
            </div>
        </div>
        <div v-if="selectedTables && selectedTables.length === 0">
            <div class="pt-3" v-if="currentRoom">
                <strong>{{ $tl("labels.booking.seatingPlan.room.config") }}</strong>
                <div class="row pt-3 pb-1">
                    <div class="col-6 pt-2">
                        {{ $tl("labels.booking.seatingPlan.room.name") }}
                    </div>
                    <div class="col-6">
                        <input
                            :disabled="!has_right_to_update_seatingplan"
                            type="text"
                            class="form-control"
                            name="number-table"
                            v-model.trim="currentRoom.name" />
                    </div>
                </div>
                <div class="row pt-1 pb-1">
                    <div class="col-6 pt-2">
                        {{ $tl("labels.startDate") }}
                    </div>
                    <div class="col-6 d-flex align-items-center date-resa-cal">
                        <DatePicker
                            :disabledDates="disabledFromDates(currentRoom)"
                            :format="DateTime.DATE_SHORT"
                            :disabled="!has_right_to_update_seatingplan"
                            :canBeEmpty="true"
                            v-model="currentRoom.datetime_begin" />
                        <feather
                            v-if="has_right_to_update_seatingplan"
                            type="x"
                            class="text-danger pointer"
                            @click="currentRoom.datetime_begin = null" />
                    </div>
                </div>
                <div class="row pt-1 pb-1">
                    <div class="col-6 pt-2">
                        {{ $tl("labels.endDate") }}
                    </div>
                    <div class="col-6 d-flex align-items-center date-resa-cal">
                        <DatePicker
                            :disabledDates="disabledToDates(currentRoom)"
                            :format="DateTime.DATE_SHORT"
                            :disabled="!has_right_to_update_seatingplan"
                            :canBeEmpty="true"
                            v-model="currentRoom.datetime_end" />
                        <feather
                            type="x"
                            class="text-danger pointer"
                            @click="has_right_to_update_seatingplan ? (currentRoom.datetime_end = null) : undefined" />
                    </div>
                </div>
                <div class="row pt-3 pb-1">
                    <div class="col-8 pt-1">
                        {{ $tl("labels.booking.seatingPlan.nbTables") }}
                    </div>
                    <div class="col-4 pt-1 text-end">
                        {{ tablesCountPerRoom }}
                    </div>
                </div>
                <div class="row pb-1">
                    <div class="col-8 pt-1">
                        {{ $tl("labels.booking.seatingPlan.nbSeats") }}
                    </div>
                    <div class="col-4 pt-1 text-end">
                        {{ seatsCountInCurrentRoom }}
                    </div>
                </div>
            </div>
        </div>
        <div v-if="selectedTableIsCounter" class="pt-3">
            <div class="row pb-1">
                <div class="col-7 pt-2">
                    {{ $tl("labels.form.name") }}
                </div>
                <div class="col-5">
                    <input
                        :disabled="!has_right_to_update_seatingplan"
                        type="text"
                        class="form-control"
                        name="name-counter"
                        v-model.trim="firstSelectedTableName" />
                </div>
            </div>
        </div>
        <div class="pt-3" v-if="selectedTablesAreTables && selectedTables && selectedTables.length === 1">
            <div class="row pb-1">
                <div class="col-9">
                    <strong>{{ $tl("labels.booking.seatingPlan.table.config") }}</strong>
                    <feather
                        v-tooltip="getTooltipNoticeLexicon('notices.booking.tablePlan.disablingTable', restaurant_id)"
                        type="info"
                        class="ms-1 pointer tooltip-infos" />
                </div>
                <div class="col-3">
                    <div class="d-inline-block align-middle lead-switch" v-tooltip="getTooltip($t('labels.booking.seatingPlan.table.toggleEnabled'))">
                        <input
                            :disabled="!has_right_to_update_seatingplan"
                            type="checkbox"
                            class="switch align-self-center is-rounded"
                            :checked="selectedTables[0].enabled" />
                        <label class="form-label" @click="selectedTables[0].enabled = !selectedTables[0].enabled"></label>
                    </div>
                </div>
            </div>
            <div class="row pt-2 pb-1">
                <div class="col-7 pt-2">
                    {{ $tl("labels.booking.seatingPlan.table.number") }}
                </div>
                <div class="col-5">
                    <input
                        :disabled="!has_right_to_update_seatingplan"
                        type="text"
                        class="form-control"
                        name="number-table"
                        v-model.trim="firstSelectedTableName" />
                </div>
            </div>
            <div class="row pb-1">
                <div class="col-7 pt-1">
                    {{ $tl("labels.booking.seatingPlan.table.size") }}
                </div>
                <div class="col-5">
                    <select
                        :disabled="!has_right_to_update_seatingplan"
                        v-model.number="selectedTables[0].seats"
                        class="form-select align-middle d-inline-block">
                        <option
                            v-for="(n, index) in $_.range(getMinTableSeats(selectedTables[0].type), getMaxTableSeats(selectedTables[0].type) + 1)"
                            :value="n"
                            :key="index">
                            {{ n }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row pb-1">
                <div class="col-12 pt-1">
                    {{ $tl("labels.booking.seatingPlan.table.enabledPax") }}
                </div>
                <div class="col-12 pt-3">
                    <label v-for="(pax, index) in selectedTables[0].seats + 2" class="form-label container-box" :key="index">
                        <input
                            :disabled="!has_right_to_update_seatingplan"
                            type="checkbox"
                            v-model.number="selectedTables[0].enabledPax"
                            :value="pax" />
                        <span class="checkmark"></span> {{ pax }}
                    </label>
                </div>
            </div>
        </div>
        <div class="pt-3" v-if="selectedGroup !== null">
            <div class="row pb-1">
                <div class="col-9">
                    <strong>{{ $tl("labels.booking.seatingPlan.group.config") }}</strong>
                </div>
                <div class="col-3">
                    <div class="d-inline-block align-middle lead-switch" v-tooltip="getTooltip($t('labels.booking.seatingPlan.group.toggleEnabled'))">
                        <input
                            :disabled="!has_right_to_update_seatingplan"
                            type="checkbox"
                            class="switch align-self-center is-rounded"
                            :checked="selectedGroup.enabled" />
                        <label class="form-label" @click="selectedGroup.enabled = !selectedGroup.enabled"></label>
                    </div>
                </div>
            </div>
            <div class="row pt-2 pb-1">
                <div class="col-7 pt-2">
                    {{ $tl("labels.booking.seatingPlan.group.name") }}
                </div>
                <div class="col-5">
                    <input
                        :disabled="!has_right_to_update_seatingplan"
                        type="text"
                        class="form-control"
                        name="group-name"
                        v-model.trim="selectedGroup.name" />
                </div>
            </div>
            <div class="row pb-1">
                <div class="col-7 pt-1">
                    {{ $tl("labels.booking.seatingPlan.group.size") }}
                </div>
                <div class="col-5">
                    <input
                        :disabled="!has_right_to_update_seatingplan"
                        style="margin-bottom: 10px"
                        type="text"
                        class="form-control"
                        name="group-size"
                        v-model.trim="selectedGroupSize"
                        disabled
                        readonly />
                </div>
            </div>
            <div class="row pb-1">
                <div class="col-12 pt-1">
                    {{ $tl("labels.booking.seatingPlan.group.enabledPax") }}
                </div>
                <div class="col-12 pt-3">
                    <label v-for="(pax, index) in selectedGroupSize + 4" class="form-label container-box" :key="index">
                        <input :disabled="!has_right_to_update_seatingplan" type="checkbox" v-model.number="selectedGroup.enabledPax" :value="pax" />
                        <span class="checkmark"></span> {{ pax }}
                    </label>
                </div>
            </div>
        </div>
        <div class="pt-3" v-if="selectedTablesAreTables && selectedTables && selectedTables.length > 1">
            <div v-if="selectedGroupId === null">
                <div class="row pb-1">
                    <div class="col-12 mb-2">
                        <strong>{{ $tl("labels.booking.seatingPlan.table.selected") }}</strong>
                        <button
                            :disabled="!has_right_to_update_seatingplan"
                            type="button"
                            class="btn btn-success btn-circle btn-sm d-inline-block float-end"
                            @click="$emit('group-selected-tables')">
                            {{ $tl("labels.booking.seatingPlan.table.group") }}
                        </button>
                    </div>
                    <div class="col-12 pt-1">
                        <ul class="list-group">
                            <li v-for="table in selectedTables" class="list-group-item" :key="table.id">
                                <div class="row">
                                    <div class="col-7">
                                        {{ $t("labels.booking.seatingPlan.table.name", { name: table.name }) }}
                                    </div>
                                    <div class="col-5">
                                        {{ $tc("labels.booking.seatingPlan.countSeats", table.seats) }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "../forms/DatePicker.vue";
import { DateTime } from "luxon";
import SeatingPlanColorTypeEnum from "../../mixins/enums/booking/SeatingPlanColorTypeEnum";
import ElementsReference from "../../mixins/helpers/booking/seating_plan/ElementsReference";
import SeatingPlanTableDetailsTypesEnum from "../../mixins/enums/booking/SeatingPlanTableDetailsTypesEnum";
import SeatingPlanTableTypesEnum from "../../mixins/enums/booking/SeatingPlanTableTypesEnum";
import ShowElementsCategory from "./ShowElementsCategory";

export default {
    name: "SeatingPlanSidebar",
    data() {
        return {
            DateTime,
            selectMode: {
                happening: false,
                positions: {
                    start: null,
                    current: null,
                },
            },
            mode: "move",
        };
    },
    mixins: [SeatingPlanColorTypeEnum, ElementsReference, SeatingPlanTableDetailsTypesEnum, SeatingPlanTableTypesEnum],
    props: {
        selectedTablesId: {
            default: () => [],
            type: Array,
        },
        selectedTables: {
            default: () => [],
            type: Array,
        },
        selectedGroupId: {
            default: null,
            type: String,
        },
        currentRoom: {
            default: null,
            type: Object,
        },
        mainStage: {
            default: null,
            type: Object,
        },
        rooms: {
            default: () => [],
            type: Array,
        },
        baseStyle: {
            required: true,
        },
        seatingPlanId: {
            required: true,
        },
        seatingPlanName: {
            default: "",
        },
        seatingPlanColorType: {
            default: "unique",
        },
    },
    computed: {
        canChangeSelectedTablesSize() {
            return this.selectedTables.length > 0 && this.selectedTables.every((table) => table.size !== undefined);
        },
        selectedTablesAreTables() {
            return this.selectedTables.length > 0 && this.selectedTables.every((table) => table.seats > 0);
        },
        selectedTableIsCounter() {
            return this.selectedTables.length === 1 && this.selectedTables[0].type === this.TABLE_TYPE_COUNTER.value;
        },
        seatingPlanName_: {
            get() {
                return this.seatingPlanName;
            },
            set(name) {
                this.$emit("set-name", name);
            },
        },
        seatingPlanColorType_: {
            get() {
                return this.seatingPlanColorType;
            },
            set(color) {
                this.$emit("set-color-type", color);
            },
        },
        restaurant_id() {
            return this.$route.params.restaurant_id;
        },
        rights: function () {
            return this.$store.getters["users/formattedRights"];
        },
        has_right_to_update_seatingplan() {
            return this.rights.includes("booking.seatingplan.update");
        },
        seatsCountInCurrentRoom() {
            var result = 0;

            this.currentRoom.tables.forEach((table) => {
                result += table.seats;
            });

            return result;
        },
        tablesCountInAllRooms() {
            var result = 0;

            if (this.rooms && this.rooms.length > 0) {
                this.rooms.forEach((room) => {
                    result += room.tables.filter((table) => table.seats).length;
                });
            }

            return result;
        },
        tablesCountPerRoom() {
            if (this.currentRoom) {
                return this.currentRoom.tables.filter((table) => table.seats).length;
            }

            return 0;
        },
        seatsCountInAllRooms() {
            var result = 0;

            if (this.rooms && this.rooms.length > 0) {
                this.rooms.forEach((room) => {
                    room.tables.forEach((table) => {
                        result += table.seats;
                    });
                });
            }

            return result;
        },
        firstSelectedTableName: {
            get: function () {
                if (this.selectedTables && this.selectedTables.length > 0) {
                    return this.selectedTables[0].name;
                }

                return "";
            },
            set: function (newValue) {
                if (this.selectedTables && this.selectedTables.length > 0) {
                    this.$set(this.selectedTables[0], "name", newValue);
                    //get Label text which contains the name of the table
                    this.changeFirstSelectedTableLabelText(newValue);
                }
            },
        },
        firstSelectedTableSeats() {
            if (this.selectedTables.length > 0) {
                return this.selectedTables[0].seats;
            }

            return null;
        },
        selectedGroup() {
            var result = null;

            if (this.selectedGroupId) {
                result = this.findGroupById(this.selectedGroupId);
            }

            return result;
        },
        selectedGroupSize() {
            var result = 0;

            if (this.selectedGroup) {
                this.selectedGroup.tables.forEach((table) => {
                    result += table.seats;
                });
            }

            return result;
        },
    },
    mounted() {
        this.ALL_TABLE_DETAILS_TYPES.forEach((tableDetails) => this.makeDraggable(this.$refs[tableDetails.ref]));
    },
    methods: {
        getTooltipAddElement(tableDetailsTypeValue) {
            return {
                delay: {
                    show: 400,
                    hide: 0,
                },
                content: this.$t("labels.booking.seatingPlan.elements.add", {
                    element: this.getTableDetailsTypeLabel(tableDetailsTypeValue),
                }),
            };
        },
        disabledFromDates(room) {
            if (room.datetime_end !== null) {
                return {
                    from: room.datetime_end.toJSDateCustom(),
                };
            }
            return undefined;
        },
        disabledToDates(room) {
            if (room.datetime_begin !== null) {
                return {
                    to: room.datetime_begin.toJSDateCustom(),
                };
            }
            return undefined;
        },
        //Set html <svg> draggable
        makeDraggable(el) {
            const self = this;
            el.draggable = true;

            el.addEventListener(
                "dragstart",
                (e) => {
                    el.style.opacity = "0.4";

                    self.$emit("dragged", {
                        type: e.target.dataset.type,
                        seats: e.target.dataset.seats,
                        size: e.target.dataset.size,
                    });
                },
                false
            );

            el.addEventListener("dragend", (e) => {
                el.style.opacity = "1";
                self.$emit("dragged", null);
            });
        },
        rotateAPoint({ x, y }, rad) {
            const rcos = Math.cos(rad);
            const rsin = Math.sin(rad);

            // Math formula of point rotation
            return { x: x * rcos - y * rsin, y: y * rcos + x * rsin };
        },
        //Rotation of a table
        // cw -> clockwise
        // ccw -> counter clockwise
        rotate(mode = "cw") {
            let rotation = 0; //degrees
            if (mode === "cw") {
                rotation = 10;
            } else if (mode === "ccw") {
                rotation = -10;
            }

            this.selectedTables.forEach((selectedTable) => {
                const tableLabelGroups = this.currentRoom.layer.find((node) => {
                    return this.ALL_TABLE_TYPES_LABELS.includes(node.name()) && selectedTable.id === node.id();
                });

                tableLabelGroups.forEach((tableLabelGroup) => {
                    // get the tables group
                    const tables = tableLabelGroup.getChildren((node) => {
                        return this.inEnum(node.name(), this.ALL_TABLE_TYPES);
                    });

                    // for each table, apply the rotation
                    tables.forEach((table, index) => {
                        const topLeft = {
                            x:
                                table.getClientRect({ skipTransform: true }).x -
                                (table.getClientRect({ skipTransform: true }).x + table.getClientRect({ skipTransform: true }).width / 2),
                            y:
                                table.getClientRect({ skipTransform: true }).y -
                                (table.getClientRect({ skipTransform: true }).y + table.getClientRect({ skipTransform: true }).height / 2),
                        };

                        const current = this.rotateAPoint(topLeft, Konva.getAngle(table.rotation()));
                        const rotated = this.rotateAPoint(topLeft, Konva.getAngle(table.rotation() + rotation));
                        const dx = rotated.x - current.x;
                        const dy = rotated.y - current.y;
                        const newRotation = table.rotation() + rotation;

                        if (index === 0) {
                            selectedTable.rotation = newRotation;
                        }

                        table.rotation(newRotation);
                        table.x(table.x() + dx);
                        table.y(table.y() + dy);
                    });
                });
            });
            this.currentRoom.layer.batchDraw();
        },
        tableGroups(tableId) {
            let groups = [];
            this.currentRoom.groups.forEach((group) => {
                group.tables.forEach((table) => {
                    if (!groups.includes(group.id) && table.id === tableId) groups.push(group.id);
                });
            });
            return groups;
        },
        // remove selected tables
        remove(force) {
            if (
                this.seatingPlanId !== null &&
                !force &&
                this.selectedTablesId &&
                this.selectedTablesId.length > 0 &&
                this.currentRoom.serverId !== null
            ) {
                let tables = [];
                this.selectedTables.forEach((table) => tables.push(table.id));
                if (tables.length > 0) {
                    this.$emit("start-loading");
                    axios
                        .post(`/api/restaurants/${this.restaurant_id}/seatingPlan/checkForFutureReservations`, {
                            seatingPlanId: this.seatingPlanId,
                            roomId: this.currentRoom.serverId,
                            tables,
                        })
                        .then((response) => {
                            this.$emit("stop-loading");
                            if (response.data.nb_future_reservations > 0)
                                this.$notify({
                                    group: "notification",
                                    type: "warn",
                                    title: this.$tl("infos.booking.seatingPlan.futureResasOnDeletedTables"),
                                    duration: 12000,
                                });
                            this.remove(true);
                        })
                        .catch((error) => {
                            this.$emit("stop-loading");
                            if (error.response.status !== 404)
                                this.$notify({
                                    group: "notification",
                                    type: "error",
                                    title: this.getErrorMsgFromErrorResponse(error, this.$tl("errors.booking.seatingPlan.checkFutureResas")),
                                });
                        });
                }
            }

            if (this.selectedTablesId && this.selectedTablesId.length > 0) {
                // Check if tables have groups
                let tablesWithGroups = this.selectedTables.filter((table) => this.tableGroups(table.id).length > 0);
                if (tablesWithGroups.length > 0) {
                    tablesWithGroups.forEach((table) =>
                        this.tableGroups(table.id).forEach((tableGroup) => {
                            this.removeGroupFromCurrentRoom(tableGroup);
                        })
                    );
                }

                const tables = this.currentRoom.layer.find((node) => {
                    return this.ALL_TABLE_TYPES_LABELS.includes(node.name()) && this.selectedTablesId.includes(node.id());
                });

                tables.forEach((table) => {
                    table.destroy();
                });

                this.selectedTablesId.forEach((tableId) => {
                    this.removeTableFromCurrentRoom(tableId);
                });

                while (this.selectedTablesId.length > 0) {
                    this.selectedTablesId.pop();
                }
            } else if (this.selectedGroupId) {
                this.removeGroupFromCurrentRoom(this.selectedGroupId);
                this.selectedGroupId = null;
            }

            this.currentRoom.layer.batchDraw();
        },
        removeTableFromCurrentRoom(id) {
            let found = null;

            for (var i = 0; i < this.currentRoom.tables.length; i++) {
                if (this.currentRoom.tables[i].id === id) {
                    found = i;
                    break;
                }
            }

            if (found !== null) {
                this.currentRoom.tables.splice(found, 1);
            }
        },
        removeGroupFromCurrentRoom(id) {
            let found = null;

            for (var i = 0; i < this.currentRoom.groups.length; i++) {
                if (this.currentRoom.groups[i].id === id) {
                    found = i;
                    break;
                }
            }

            if (found !== null) {
                this.currentRoom.groups.splice(found, 1);
            }
        },
        //Set select mode on
        setSelectMode(e) {
            this.disableMoveMode();
            this.mode = "select";
            this.mainStage.on("mousedown", this.selectModeStartDrag);
            this.mainStage.on("mousemove", this.selectModeUpdateDrag);
            this.mainStage.on("mouseup", this.selectModeEndDrag);
        },
        // set the beggining position of the selection rectangle
        selectModeStartDrag(e) {
            const offsetX = this.currentRoom.layer.offsetX() - this.currentRoom.layer.x() / this.currentRoom.layer.scaleX();
            const offsetY = this.currentRoom.layer.offsetY() - this.currentRoom.layer.y() / this.currentRoom.layer.scaleY();

            this.selectMode.happening = true;
            this.selectMode.positions.start = {
                x: e.evt.layerX / this.currentRoom.layer.scaleX() - this.mainStage.position().x / this.currentRoom.layer.scaleX() + offsetX,
                y: e.evt.layerY / this.currentRoom.layer.scaleY() - this.mainStage.position().y / this.currentRoom.layer.scaleY() + offsetY,
            };

            this.selectMode.positions.current = {
                x: e.evt.layerX / this.currentRoom.layer.scaleX() - this.mainStage.position().x / this.currentRoom.layer.scaleX() + offsetX,
                y: e.evt.layerY / this.currentRoom.layer.scaleY() - this.mainStage.position().y / this.currentRoom.layer.scaleY() + offsetY,
            };
        },
        // update the position of the mouse in order to draw the selection square
        selectModeUpdateDrag(e) {
            const offsetX = this.currentRoom.layer.offsetX() - this.currentRoom.layer.x() / this.currentRoom.layer.scaleX();
            const offsetY = this.currentRoom.layer.offsetY() - this.currentRoom.layer.y() / this.currentRoom.layer.scaleY();

            if (this.selectMode.happening) {
                this.$set(this.selectMode.positions, "current", {
                    x: e.evt.layerX / this.currentRoom.layer.scaleX() - this.mainStage.position().x / this.currentRoom.layer.scaleX() + offsetX,
                    y: e.evt.layerY / this.currentRoom.layer.scaleY() - this.mainStage.position().y / this.currentRoom.layer.scaleY() + offsetY,
                });

                var rectPos = this.getSelectionRectPositions(this.selectMode.positions.start, this.selectMode.positions.current);

                this.currentRoom.selectionRect.moveToTop();
                this.currentRoom.selectionRect.x(rectPos.startPos.x);
                this.currentRoom.selectionRect.y(rectPos.startPos.y);
                this.currentRoom.selectionRect.width(rectPos.currentPos.x - rectPos.startPos.x);
                this.currentRoom.selectionRect.height(rectPos.currentPos.y - rectPos.startPos.y);
                this.currentRoom.selectionRect.visible(true);

                this.currentRoom.layer.batchDraw();
            }
        },
        //Get rectangle positions with a possible rotation of points if the first mouse position
        // is at the bottom right of the supposed selection array. In order to start to display the rectangle from the top left.
        getSelectionRectPositions(startPos, currentPos) {
            var result = {
                startPos: {
                    ...startPos,
                },
                currentPos: {
                    ...currentPos,
                },
            };
            // if startpos X > currentPos X, invert the position because the movement is going on the left
            // and the rectangle origin must be at the top left of it. So if we do not reverse the position
            // The rectangle would be drawn starting at the original start pos, and wouldn't follow the race of the cursor
            if (startPos.x > currentPos.x) {
                var distance = startPos.x - currentPos.x;
                result.startPos.x = currentPos.x;
                result.currentPos.x = currentPos.x + distance;
            }

            if (startPos.y > currentPos.y) {
                var distance = startPos.y - currentPos.y;
                result.startPos.y = currentPos.y;
                result.currentPos.y = currentPos.y + distance;
            }

            return result;
        },
        //Dragend of selection. Once done, items are selected and selection rectangle is reset
        selectModeEndDrag(e) {
            if (this.selectMode.happening) {
                this.selectMode.happening = false;
                this.selectModeUpdateDrag(e);
                this.$nextTick(() => {
                    var tables = this.getTablesSelectedBySelectionRect();
                    this.$emit("tables-selected", tables);

                    this.currentRoom.selectionRect.x(0);
                    this.currentRoom.selectionRect.y(0);
                    this.currentRoom.selectionRect.width(0);
                    this.currentRoom.selectionRect.height(0);
                    this.currentRoom.selectionRect.visible(false);
                    this.currentRoom.layer.batchDraw();
                });
            }
        },
        // Get the tables inside of the selection rect by looking if there are collisions with other visual items
        getTablesSelectedBySelectionRect() {
            return this.currentRoom.layer
                .getChildren((node) => this.ALL_TABLE_TYPES_LABELS.includes(node.name()))
                .filter((node) => this.hasCollision(this.currentRoom.selectionRect, node));
        },
        //Check for collision between 2 shapes
        hasCollision(shapeA, shapeB) {
            var shapeAClientRect = shapeA.getClientRect();
            var shapeBClientRect = shapeB.getClientRect();

            const collisionX =
                shapeAClientRect.x + shapeAClientRect.width >= shapeBClientRect.x &&
                shapeBClientRect.x + shapeBClientRect.width >= shapeAClientRect.x;

            const collisionY =
                shapeAClientRect.y + shapeAClientRect.height >= shapeBClientRect.y &&
                shapeBClientRect.y + shapeBClientRect.height >= shapeAClientRect.y;

            return collisionX && collisionY;
        },
        //Dragmode on
        setMoveMode() {
            this.mode = "move";
            this.disableSelectMode();
            this.mainStage.draggable(true);
        },
        //Drag mode off
        disableMoveMode() {
            this.mainStage.draggable(false);
        },
        //select mode off -> just unregister the events
        disableSelectMode() {
            this.mainStage.off("mousedown mousemove mouseup");
        },
        getMaxTableSeats(type) {
            var biggestSize = 0;

            this.elementsReference.forEach((element) => {
                if (element.type === type && element.seats > biggestSize) {
                    biggestSize = element.seats;
                }
            });

            return biggestSize;
        },
        getMinTableSeats(type) {
            var minSize = 0;

            this.elementsReference.forEach((element) => {
                if (element.type === type && (minSize === 0 || minSize > element.seats)) {
                    minSize = element.seats;
                }
            });

            return minSize;
        },
        changeFirstSelectedTableLabelText(text) {
            var labelText = this.selectedTables[0].labelText;
            //get the group (svg) of the table
            var groups = this.selectedTables[0].group.getChildren((node) => {
                return this.inEnum(node.name(), [this.TABLE_TYPE_TABLE, this.TABLE_TYPE_COUNTER]);
            });

            var group = groups[0];

            // Change text;
            labelText.text(`${text}`);

            labelText.getParent().position({
                x: group.getClientRect({ skipTransform: true }).width / 2 - labelText.getClientRect({ skipTransform: true }).width / 2,
                y: group.getClientRect({ skipTransform: true }).height / 2 - labelText.getClientRect({ skipTransform: true }).height / 2,
            });

            //Draw what needs to be drawn
            this.currentRoom.layer.batchDraw();
        },
        changeFirstSelectedTableShapeAccordingToSize(newSize) {
            const modelElement = this.findElementReference(this.selectedTables[0].type, newSize, this.selectedTables[0].size);

            if (modelElement !== null) {
                const tables = this.currentRoom.layer.find((node) => {
                    return this.ALL_TABLE_TYPES_LABELS.includes(node.name()) && this.selectedTables[0].id === node.id();
                });

                tables.forEach((table) => {
                    table.destroy();
                });

                this.selectedTables[0].seats = newSize;

                this.$emit("draw-table", {
                    table: this.selectedTables[0],
                    modelElement,
                    forceSelection: true,
                });

                this.currentRoom.layer.add(this.selectedTables[0].group);

                this.currentRoom.layer.batchDraw();
            }
        },
        findGroupById(id) {
            for (var i = 0; i < this.currentRoom.groups.length; i++) {
                const group = this.currentRoom.groups[i];

                if (group.id === id) {
                    return group;
                }
            }

            return null;
        },
    },
    watch: {
        firstSelectedTableSeats: function (newValue, oldValue) {
            if (newValue !== null && oldValue !== null) {
                this.selectedTables[0].enabledPax = [newValue];

                if (newValue !== oldValue) {
                    this.changeFirstSelectedTableShapeAccordingToSize(newValue);
                }
            }
        },
    },
    components: {
        DatePicker,
        ShowElementsCategory,
    },
};
</script>

<style>
.cls-1 {
    fill: #f8fafc;
}
</style>
